"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4891],{

/***/ 33983:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ AnalyticsPluginAdobe)
/* harmony export */ });
/* harmony import */ var _growth_object_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27106);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = _extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(_extends({}, configs));
      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = _extends({}, pluginConfig);

      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};




/***/ }),

/***/ 71956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ao": () => (/* binding */ createConfigStore),
  "a_": () => (/* binding */ setData)
});

// UNUSED EXPORTS: getConfigStoreDataClient

// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(40624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(36880);
// EXTERNAL MODULE: ../../node_modules/@growth/api-calls/dist/growth-api-calls.esm.js + 5 modules
var growth_api_calls_esm = __webpack_require__(92878);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/config-store/dist/xhr-be83704d.esm.js


function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var formatConfigResp = function formatConfigResp(configKeys) {
  var lobsKey = Object.keys(configKeys);
  var configs = lobsKey.reduce == null ? void 0 : lobsKey.reduce(function (acc, l) {
    var _configKeys$l$reduce, _configKeys$l;
    acc[l] = (_configKeys$l$reduce = (_configKeys$l = configKeys[l]).reduce) == null ? void 0 : _configKeys$l$reduce.call(_configKeys$l, function (kk, k) {
      var cloneKK = Object(kk);
      cloneKK[k.cfgKey] = k.value;
      return cloneKK;
    }, {});
    return acc;
  }, {});
  return configs;
};
var getConfigStoreData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, fetchOpts, lobList, keyList, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, fetchOpts = opts.fetchOpts;
          /**
           * Return the initData if present, this helps to use the data passed in
           * SSR and avoid the api calls on client again.
           * */
          lobList = typeof lobs === 'string' ? [lobs] : lobs;
          keyList = typeof keys === 'string' ? [keys] : keys;
          _context.next = 5;
          return (0,growth_api_calls_esm/* fetchConfigStoreData */.VE)({
            lobList: lobList,
            cfgKeyList: keyList,
            fetchOpts: {
              timeout: fetchOpts.timeout
            }
          });
        case 5:
          data = _context.sent;
          return _context.abrupt("return", formatConfigResp(data == null ? void 0 : data.configKeys));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreData(_x) {
    return _ref.apply(this, arguments);
  };
}();



// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(91917);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/browser-storage/dist/growth-browser-storage.esm.js


var BROWSER_STORAGE_TYPE = {
  LOCAL_STORAGE: growth_ssr_utils_esm/* isOnClient */.BK ? window.localStorage : '',
  SESSION_STORAGE: growth_ssr_utils_esm/* isOnClient */.BK ? window.sessionStorage : ''
};
var makeExpireTime = function makeExpireTime(sec) {
  if (sec === void 0) {
    sec = 0;
  }
  // take ttl in sec to keep the api same across all other cache utils
  var d = new Date();
  d.setSeconds(d.getSeconds() + sec);
  return d.getTime();
};
var isTimeExpired = function isTimeExpired(time) {
  return new Date().getTime() - time >= 0;
};
function storageAvailable(type) {
  var storage;
  try {
    storage = type;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}
var storage = function storage(backed) {
  return {
    setItem: function setItem(key, value, expiryTime) {
      if (!storageAvailable(backed)) return null;
      if (value === undefined) {
        backed.removeItem(key);
      } else {
        var storageValue = {
          value: value
        };
        if (expiryTime) {
          storageValue.timeStamp = makeExpireTime(expiryTime);
        }
        backed.setItem(key, JSON.stringify(storageValue));
      }
      return value;
    },
    getItem: function getItem(key) {
      if (!storageAvailable(backed)) return null;
      var value; // undefined
      var str = backed.getItem(key);
      if (str) {
        try {
          var _JSON$parse = JSON.parse(str),
            respValue = _JSON$parse.value,
            timeStamp = _JSON$parse.timeStamp;
          if (timeStamp && isTimeExpired(timeStamp)) {
            backed.removeItem(key);
          } else {
            value = respValue;
          }
        } catch (e) {
          // console.log(`Error parsing storage ['${ key }']`);
          backed.removeItem(key);
        }
      }
      return value;
    },
    removeItem: function removeItem(key) {
      if (!storageAvailable(backed)) return null;
      return backed.removeItem(key);
    }
  };
};
var getLocalStorage = function getLocalStorage() {
  return storage(BROWSER_STORAGE_TYPE.LOCAL_STORAGE);
};
var getSessionStorage = function getSessionStorage() {
  return storage(BROWSER_STORAGE_TYPE.SESSION_STORAGE);
};
var docLocalStorage = getLocalStorage();
var docSessionStorage = getSessionStorage();



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/browser-storage/indexDB/dist/growth-browser-storage-indexDB.esm.js
function growth_browser_storage_indexDB_esm_regeneratorRuntime() {
  growth_browser_storage_indexDB_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_storage_indexDB_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_storage_indexDB_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/*
 https://dev.to/alexeagleson/how-to-use-indexeddb-to-store-data-for-your-web-application-in-the-browser-1o90#browsing-your-database
*/
var requestIndexDB = function requestIndexDB(name, ver) {
  if (!name || !ver) {
    throw new Error('name or ver argument is missing for requestIndexDB');
  }
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  return new Promise(function (resolve, reject) {
    if (!indexedDB) {
      reject(new Error('IndexedDB could not be found in this browser.'));
    }
    var request = indexedDB.open(name, ver);
    resolve(request);
  });
};
var bootstrapDB = /*#__PURE__*/function () {
  var _ref = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context.prev = 1;
          _context.next = 4;
          return requestIndexDB(dbName, dbVer);
        case 4:
          request = _context.sent;
          request.onupgradeneeded = function () {
            var db = request.result;
            var store = db.createObjectStore(objectName, {
              keyPath: keyPath || 'id'
            });
            store.createIndex('expire', 'expire');
          };
          return _context.abrupt("return", request);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", Promise.reject(new Error()));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function bootstrapDB(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addNewObject = /*#__PURE__*/function () {
  var _ref2 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee2(opts) {
    var dbName, dbVer, objectName, data, expire, keyPath, id, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, data = opts.data, expire = opts.expire, keyPath = opts.keyPath, id = opts.id;
          _context2.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 3:
          request = _context2.sent;
          request.onsuccess = function () {
            var db = request.result;
            var transaction = db.transaction(objectName, 'readwrite');
            var store = transaction.objectStore(objectName);
            var expireTS;
            if (expire && typeof (expire == null ? void 0 : expire.getMonth) === 'function') {
              expireTS = new Date(expire).getTime(); // EPOC
            } else {
              var defaultExpMin = 15;
              expireTS = new Date(new Date().getTime() + defaultExpMin * 60000).getTime(); // EPOC
            }

            store.put({
              expire: expireTS,
              id: id,
              value: data
            });
            transaction.oncomplete = function () {
              db.close();
            };
          };
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function addNewObject(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var removeExpiredObjects = function removeExpiredObjects(_ref3) {
  var db = _ref3.db,
    objectName = _ref3.objectName;
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction([objectName], 'readwrite');
    var objectStore = transaction.objectStore(objectName);
    var expirationIndex = objectStore.index('expire');
    var now = new Date().getTime();
    var request = expirationIndex.openCursor(IDBKeyRange.upperBound(now));
    var deletePromises = [];
    request.onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        var deleteRequest = objectStore["delete"](cursor.primaryKey);
        deletePromises.push(new Promise(function (resolveDelete, rejectDelete) {
          // console.log('deleting idb', cursor.primaryKey);
          deleteRequest.onsuccess = resolveDelete;
          deleteRequest.onerror = rejectDelete;
        }));
        cursor["continue"]();
      } else {
        // delete all
        Promise.all(deletePromises).then(function () {
          return resolve('deleted');
        })["catch"](reject);
      }
    };
    request.onerror = reject;
  });
};
var getAllObjects = /*#__PURE__*/function () {
  var _ref4 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee4(opts) {
    var dbName, dbVer, objectName, id, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, id = opts.id, keyPath = opts.keyPath;
          if (id) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", Promise.reject(Error("Argument id is missing for getAllObjects() call")));
        case 3:
          _context4.next = 5;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName,
            keyPath: keyPath
          });
        case 5:
          request = _context4.sent;
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = /*#__PURE__*/growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee3() {
              var db, transaction, store, records;
              return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    db = request.result; // let's delete all expired records
                    _context3.next = 3;
                    return removeExpiredObjects({
                      db: db,
                      objectName: objectName
                    });
                  case 3:
                    transaction = db.transaction(objectName, 'readonly');
                    store = transaction.objectStore(objectName); // get a record
                    records = store.getAll(id);
                    records.onsuccess = function () {
                      var _records$result;
                      resolve((_records$result = records.result) == null || (_records$result = _records$result[0]) == null ? void 0 : _records$result.value);
                    };
                    request.onerror = function () {
                      reject(records.result);
                    };
                    transaction.oncomplete = function () {
                      db.close();
                    };
                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
          }));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getAllObjects(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var deleteObject = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = growth_browser_storage_indexDB_esm_asyncToGenerator( /*#__PURE__*/growth_browser_storage_indexDB_esm_regeneratorRuntime().mark(function _callee5(opts) {
    var dbName, dbVer, objectName, keyPath, request;
    return growth_browser_storage_indexDB_esm_regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          dbName = opts.dbName, dbVer = opts.dbVer, objectName = opts.objectName, keyPath = opts.keyPath;
          _context5.next = 3;
          return bootstrapDB({
            dbName: dbName,
            dbVer: dbVer,
            objectName: objectName
          });
        case 3:
          request = _context5.sent;
          return _context5.abrupt("return", new Promise(function (resolve, reject) {
            request.onsuccess = function () {
              var db = request.result;
              var transaction = db.transaction(objectName, 'readwrite');
              var store = transaction.objectStore(objectName);
              store["delete"](keyPath);
              transaction.oncomplete = function () {
                db.close();
                resolve('delete');
              };
              transaction.onerror = function (e) {
                db.close();
                reject(e);
              };
            };
          }));
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function deleteObject(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/browser-caching/dist/growth-browser-caching.esm.js



function growth_browser_caching_esm_regeneratorRuntime() {
  growth_browser_caching_esm_regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function growth_browser_caching_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var SESSION_STORE = 'sessionStorage';
var LOCAL_STORE = 'localStorage';
var INDEX_DB = 'indexDb';
var INDEX_DB_DETAILS = {
  objectName: 'with-cache',
  keyPath: 'id',
  dbName: 'grow-with-fetch-cache',
  dbVer: 1
};
var withBrowserStorageCaching = /*#__PURE__*/function () {
  var _ref = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee3(opts) {
    var key, asyncMethod, _opts$ttl, ttl, type, _opts$cacheResponseKe, cacheResponseKeys, ignoreCache, revalidate, initData, getLocalStore, isLocalStore, getItem, setItem, cache, res, saveResp;
    return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          key = opts.key, asyncMethod = opts.asyncMethod, _opts$ttl = opts.ttl, ttl = _opts$ttl === void 0 ? 0 : _opts$ttl, type = opts.type, _opts$cacheResponseKe = opts.cacheResponseKeys, cacheResponseKeys = _opts$cacheResponseKe === void 0 ? [] : _opts$cacheResponseKe, ignoreCache = opts.ignoreCache, revalidate = opts.revalidate, initData = opts.initData; // ignore the caching if ignoreCache is true
          if (!ignoreCache) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", asyncMethod());
        case 3:
          if (key) {
            _context3.next = 5;
            break;
          }
          throw new Error('withBrowserStorageCaching: For browser caching key name is mandatory');
        case 5:
          getLocalStore = function getLocalStore() {
            return type === SESSION_STORE ? docSessionStorage : docLocalStorage;
          };
          isLocalStore = function isLocalStore(_type) {
            return _type === LOCAL_STORE || _type === SESSION_STORE || _type === undefined;
          };
          getItem = /*#__PURE__*/function () {
            var _ref2 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee() {
              var store, value, dbName, dbVer, objectName, keyPath, record;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!isLocalStore(opts.type)) {
                      _context.next = 4;
                      break;
                    }
                    store = getLocalStore();
                    value = store.getItem(key);
                    return _context.abrupt("return", value);
                  case 4:
                    if (!(opts.type === INDEX_DB)) {
                      _context.next = 10;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context.next = 8;
                    return getAllObjects({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      id: key,
                      keyPath: keyPath
                    });
                  case 8:
                    record = _context.sent;
                    return _context.abrupt("return", record);
                  case 10:
                    return _context.abrupt("return", undefined);
                  case 11:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function getItem() {
              return _ref2.apply(this, arguments);
            };
          }();
          setItem = /*#__PURE__*/function () {
            var _ref3 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee2(value) {
              var store, dbName, dbVer, objectName, keyPath, res;
              return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!isLocalStore(type)) {
                      _context2.next = 3;
                      break;
                    }
                    store = getLocalStore();
                    return _context2.abrupt("return", store.setItem(key, value, ttl));
                  case 3:
                    if (!(opts.type === INDEX_DB)) {
                      _context2.next = 9;
                      break;
                    }
                    dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                    _context2.next = 7;
                    return addNewObject({
                      dbName: dbName,
                      dbVer: dbVer,
                      objectName: objectName,
                      keyPath: keyPath,
                      id: key,
                      data: value,
                      expire: ttl ? new Date(new Date().getTime() + ttl * 60000) : undefined
                    });
                  case 7:
                    res = _context2.sent;
                    return _context2.abrupt("return", res);
                  case 9:
                    return _context2.abrupt("return", undefined);
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function setItem(_x2) {
              return _ref3.apply(this, arguments);
            };
          }();
          /** return the initData if present, this helps to use the data passed in SSR and avoid the api calls on client again. */
          if (!(!ignoreCache && !revalidate && initData)) {
            _context3.next = 11;
            break;
          }
          return _context3.abrupt("return", Promise.resolve(initData));
        case 11:
          _context3.next = 13;
          return getItem();
        case 13:
          cache = _context3.sent;
          if (!(cache && !revalidate)) {
            _context3.next = 16;
            break;
          }
          return _context3.abrupt("return", cache);
        case 16:
          if (!(typeof asyncMethod === 'function')) {
            _context3.next = 22;
            break;
          }
          _context3.next = 19;
          return asyncMethod();
        case 19:
          res = _context3.sent;
          // keep only few keys in cache instead of whole response.
          if (typeof res === 'object' && cacheResponseKeys.length) {
            saveResp = {};
            cacheResponseKeys.forEach(function (item) {
              saveResp[item] = res == null ? void 0 : res[item];
            });
            setItem(saveResp);
          } else {
            setItem(res);
          }
          return _context3.abrupt("return", res);
        case 22:
          throw new Error('withBrowserStorageCaching: the second parameter should be async method');
        case 23:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function withBrowserStorageCaching(_x) {
    return _ref.apply(this, arguments);
  };
}();



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js






function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var getConfigStoreDataClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, cacheOpts, fetchOpts, initData, cacheKey, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lobs = opts.lobs, keys = opts.keys, cacheOpts = opts.cacheOpts, fetchOpts = opts.fetchOpts, initData = opts.initData;
          cacheKey = function cacheKey() {
            // merge the lob and keys to make a cachekey
            var l = typeof lobs === 'string' ? [lobs] : lobs;
            var k = typeof keys === 'string' ? [keys] : keys;
            var ckey = l.join('-') + "-" + k.join('-');
            return ckey.toLowerCase();
          };
          _context.next = 4;
          return withBrowserStorageCaching({
            key: cacheKey(),
            asyncMethod: function asyncMethod() {
              return getConfigStoreData({
                lobs: lobs,
                keys: keys,
                fetchOpts: {
                  timeout: (fetchOpts == null ? void 0 : fetchOpts.timeout) || 2000
                }
              });
            },
            initData: initData,
            ttl: (cacheOpts == null ? void 0 : cacheOpts.ttl) || 15 /* minutes */,
            ignoreCache: cacheOpts == null ? void 0 : cacheOpts.ignoreCache,
            revalidate: cacheOpts == null ? void 0 : cacheOpts.revalidate,
            type: 'indexDb'
          });
        case 4:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigStoreDataClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createConfigStore = function createConfigStore() {
  return (0,esm/* create */.Ue)()(function (set) {
    return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
      fetch: function fetch(opts) {
        return (0,growth_store_helpers_esm/* fetchSetter */.x)({
          set: set,
          fetchFun: function fetchFun() {
            return getConfigStoreDataClient({
              lobs: opts.lobs,
              keys: opts.keys,
              cacheOpts: opts == null ? void 0 : opts.cacheOpts,
              initData: opts == null ? void 0 : opts.initData
            });
          },
          onSuccess: opts == null ? void 0 : opts.onSuccess
        });
      }
    });
  });
};
var setData = function setData(store, value) {
  return store.setState(function (s) {
    return {
      data: _extends({}, s.data, value),
      loaded: true
    };
  });
};




/***/ }),

/***/ 66687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xv": () => (/* reexport */ Text),
  "$G": () => (/* reexport */ headingSizes),
  "iH": () => (/* reexport */ textSizes)
});

// UNUSED EXPORTS: Box, Heading, breakPoints, buildTheme, colors, defaultTheme, font, misc, spacing, useTheme, withDeviceTheme

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/typography-c0cdeefc.esm.js
// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/

// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal';

//  Lable
var textSizes = {
  LargeW1: {
    'font-weight': fwRegular,
    'font-size': fs18,
    'line-height': lhAuto
  },
  LargeW2: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwMedium
  },
  LargeW3: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwRegular
  },
  MediumW2: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwMedium
  },
  MediumW3: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  },
  BaseW1: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwRegular
  },
  BaseW2: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwMedium
  },
  BaseW3: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwSemiBold
  },
  SmallW1: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwRegular
  },
  SmallW2: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwMedium
  },
  SmallW3: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwSemiBold
  }
};

//  Lable
var headingSizes = {
  xLarge: {
    'font-weight': fwBold,
    'font-size': fs32,
    'line-height': lhAuto
  },
  Large: {
    'line-height': lhAuto,
    'font-size': fs24,
    'font-weight': fwBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs22,
    'font-weight': fwSemiBold
  },
  Small: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  Base: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  }
};



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/index-2b47df9d.esm.js


// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0

var spacing = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};
var buildSpacing = function buildSpacing() {
  return spacing;
};

var Box = styled_components_browser_esm/* default.div */.ZP.div(function (_ref) {
  var _ref$mr = _ref.mr,
    mr = _ref$mr === void 0 ? '' : _ref$mr,
    _ref$mt = _ref.mt,
    mt = _ref$mt === void 0 ? '' : _ref$mt,
    _ref$ml = _ref.ml,
    ml = _ref$ml === void 0 ? '' : _ref$ml,
    _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? '' : _ref$mb,
    _ref$my = _ref.my,
    my = _ref$my === void 0 ? '' : _ref$my,
    _ref$mx = _ref.mx,
    mx = _ref$mx === void 0 ? '' : _ref$mx,
    _ref$pt = _ref.pt,
    pt = _ref$pt === void 0 ? '' : _ref$pt,
    _ref$pr = _ref.pr,
    pr = _ref$pr === void 0 ? '' : _ref$pr,
    _ref$pb = _ref.pb,
    pb = _ref$pb === void 0 ? '' : _ref$pb,
    _ref$pl = _ref.pl,
    pl = _ref$pl === void 0 ? '' : _ref$pl,
    _ref$py = _ref.py,
    py = _ref$py === void 0 ? '' : _ref$py,
    _ref$px = _ref.px,
    px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing[mr || mx] || '') + ";\n\tmargin-left: " + (spacing[ml || mx] || '') + ";\n\tmargin-top: " + (spacing[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing[mb || my] || '') + ";\n\tpadding-right: " + (spacing[pr || px] || '') + ";\n\tpadding-left: " + (spacing[pl || px] || '') + ";\n\tpadding-top: " + (spacing[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing[pb || py] || '') + ";\n";
});



// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/taggedTemplateLiteralLoose-7a042257.esm.js
var taggedTemplateLiteralLoose_7a042257_esm = __webpack_require__(23850);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/components/text/dist/growth-design-system-components-text.esm.js




var _templateObject;
var Text = styled_components_browser_esm/* default.p */.ZP.p(_templateObject || (_templateObject = (0,taggedTemplateLiteralLoose_7a042257_esm._)(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/components/heading/dist/growth-design-system-components-heading.esm.js




var growth_design_system_components_heading_esm_templateObject;
var Heading = styled_components_browser_esm/* default.h2 */.ZP.h2(growth_design_system_components_heading_esm_templateObject || (growth_design_system_components_heading_esm_templateObject = (0,taggedTemplateLiteralLoose_7a042257_esm._)(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return headingSizes[size || 'Large'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/growth-design-system.esm.js










function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: {
    label: _extends({}, textSizes),
    heading: _extends({}, headingSizes)
  }
};
var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }
  return _extends({}, fontThemeProperties);
};

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px
  }
};

function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }
  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem

      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px
    },

    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var growth_design_system_esm_spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: growth_design_system_esm_spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}

/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */
var defaultTheme = buildTheme();

/**
 * to check if theme exists on caller, else return defaultTheme
 */
function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}
var withDeviceTheme = function withDeviceTheme(config) {
  return _extends({}, config == null ? void 0 : config.theme, {
    deviceConstraints: _extends({}, config == null ? void 0 : config.deviceConstraints),
    designConfig: config == null ? void 0 : config.designConfig
  });
};




/***/ }),

/***/ 23850:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ _taggedTemplateLiteralLoose)
/* harmony export */ });
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}




/***/ }),

/***/ 68499:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": () => (/* binding */ CONFIG_KEY_DWEB_AUTH),
  "Z": () => (/* binding */ Container)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(64993);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../node_modules/@growth/app-theme/dist/growth-app-theme.esm.js
var growth_app_theme_esm = __webpack_require__(21225);
// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(22019);
// EXTERNAL MODULE: ../../node_modules/@growth/object-utils/dist/growth-object-utils.esm.js
var growth_object_utils_esm = __webpack_require__(27106);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/gi-dweb-auth/node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = _extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,growth_object_utils_esm/* deepClone */.I8)(_extends({}, configs));
      (0,growth_object_utils_esm/* deepMerge */.RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = _extends({}, pluginConfig);

      (0,growth_object_utils_esm/* deepMerge */.RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};



// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(92532);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js + 2 modules
var growth_auth_helpers_esm = __webpack_require__(65614);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(63377);
// EXTERNAL MODULE: ../../node_modules/@growth/pdt-push/dist/growth-pdt-push.esm.js
var growth_pdt_push_esm = __webpack_require__(93488);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/growth-design-system.esm.js + 4 modules
var growth_design_system_esm = __webpack_require__(66687);
;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/dist/taggedTemplateLiteralLoose-7a042257.esm.js
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}



// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var dist_growth_design_system_esm = __webpack_require__(53767);
;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/input-feild/dist/growth-form-controls-input-feild.esm.js




function growth_form_controls_input_feild_esm_extends() {
  growth_form_controls_input_feild_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return growth_form_controls_input_feild_esm_extends.apply(this, arguments);
}

var _templateObject, _templateObject2;
var Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 10px;\n\tborder: solid 1px #d8d8d8;\n\tborder-radius: 6px;\n\tfont-size: 14px;\n\tbox-shadow: 0px 1px 4px 0px #00000026;\n\twidth: 100%;\n\t", ";\n"])), function (props) {
  return props.customStyle && growth_form_controls_input_feild_esm_extends({}, props.customStyle);
});
var Input = styled_components_browser_esm/* default.input */.ZP.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tborder: none;\n\toutline: none;\n\twidth: calc(100% - 20px);\n\tbackground: transparent;\n\tmargin-left: 10px;\n"])));

var InputField = function InputField(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    _onChange = _ref.onChange,
    fullView = _ref.fullView,
    inputName = _ref.inputName,
    inputDisabled = _ref.inputDisabled,
    inputWrapStyle = _ref.inputWrapStyle,
    children = _ref.children;
  return /*#__PURE__*/react.createElement(Wrap, {
    customStyle: inputWrapStyle
  }, fullView && children, /*#__PURE__*/react.createElement(Input, {
    type: "text",
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      return _onChange == null ? void 0 : _onChange(e.target.value);
    },
    fullView: fullView,
    name: inputName,
    disabled: inputDisabled
  }));
};
InputField.defaultProps = {
  inputName: '',
  inputDisabled: false,
  onChange: undefined,
  value: undefined,
  inputWrapStyle: undefined,
  children: undefined
};



;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/dist/index-c92acf6a.esm.js






var _templateObject$1, index_c92acf6a_esm_templateObject2, _templateObject3;
var fullViewStyle = "\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100vh;\n\tborder-radius: 0;\n\toverflow: scroll;\n";
var index_c92acf6a_esm_Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 310px;\n\theight: 225px;\n\tborder-radius: 8px;\n\tbackground: #fff;\n\tpadding: 15px;\n\tbox-shadow: rgba(0, 0, 0, 0.2) -5px 0px 9px 0px;\n\tz-index: 1024;\n\t", "\n"])), function (props) {
  return props.fullView ? fullViewStyle : '';
});
var Header = styled_components_browser_esm/* default.p */.ZP.p(index_c92acf6a_esm_templateObject2 || (index_c92acf6a_esm_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #222222;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t& .close {\n\t\tposition: relative;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\topacity: 0.9;\n\t\tmargin-right: 10px;\n\t}\n\t& .close:before,\n\t& .close:after {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\tcontent: ' ';\n\t\theight: 20px;\n\t\twidth: 2px;\n\t\tbackground-color: #333;\n\t}\n\t& .close:before {\n\t\ttransform: rotate(45deg);\n\t}\n\t& .close:after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])), dist_growth_design_system_esm/* textSizes.LargeW2 */.iH.LargeW2);
var Title = styled_components_browser_esm/* default.p */.ZP.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tcolor: #b0b0b0;\n\tmargin: 10px 0;\n"])));

var index_c92acf6a_esm_templateObject;
var List$1 = styled_components_browser_esm/* default.div */.ZP.div(index_c92acf6a_esm_templateObject || (index_c92acf6a_esm_templateObject = _taggedTemplateLiteralLoose(["\n\tlist-style-type: none;\n\tpadding: 0;\n\tmargin: 0;\n\toverflow: hidden;\n\toverflow-y: auto;\n"])));

var List = function List(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/react.createElement(List$1, null, options.map(function (option) {
    return option;
  }));
};

var Dropdown = function Dropdown(props) {
  var _props$showSearchFiel = props.showSearchField,
    showSearchField = _props$showSearchFiel === void 0 ? false : _props$showSearchFiel,
    _props$fullView = props.fullView,
    fullView = _props$fullView === void 0 ? false : _props$fullView,
    options = props.options,
    handleInputSearch = props.handleInputSearch,
    heading = props.heading,
    listTitle = props.listTitle,
    handleDropDownClose = props.handleDropDownClose,
    searchFieldPlaceholder = props.searchFieldPlaceholder,
    bodyCompoment = props.bodyCompoment;
  var _useState = (0,react.useState)(''),
    inputSearchValue = _useState[0],
    setInputSearchValue = _useState[1];
  var handleInputFieldSearch = function handleInputFieldSearch(value) {
    setInputSearchValue(value);
    handleInputSearch == null || handleInputSearch(value);
  };
  return /*#__PURE__*/react.createElement(index_c92acf6a_esm_Wrap, {
    fullView: fullView
  }, fullView && /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement("span", {
    role: "presentation",
    className: "close",
    onClick: handleDropDownClose
  }), heading), showSearchField ? /*#__PURE__*/react.createElement(InputField, {
    fullView: fullView,
    value: inputSearchValue,
    placeholder: searchFieldPlaceholder || '',
    onChange: handleInputFieldSearch,
    inputWrapStyle: {
      boxShadow: 'unset'
    }
  }) : null, listTitle ? /*#__PURE__*/react.createElement(Title, null, listTitle) : null, bodyCompoment || options && /*#__PURE__*/react.createElement(List, {
    options: options
  }));
};
Dropdown.defaultProps = {
  fullView: false,
  handleInputSearch: undefined,
  showSearchField: false,
  handleDropDownClose: undefined,
  heading: '',
  searchFieldPlaceholder: '',
  bodyCompoment: null,
  options: []
};



;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/dropdown/dist/growth-form-controls-dropdown.esm.js







// EXTERNAL MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js + 1 modules
var growth_loader_esm = __webpack_require__(10305);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 4 modules
var growth_config_store_browser_esm = __webpack_require__(71956);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/dist/taggedTemplateLiteralLoose-7a042257.esm.js
var taggedTemplateLiteralLoose_7a042257_esm = __webpack_require__(23850);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/design-system/components/countryList/dist/growth-design-system-components-countryList.esm.js




var growth_design_system_components_countryList_esm_templateObject;
var CountryImg$1 = styled_components_browser_esm/* default.span */.ZP.span(growth_design_system_components_countryList_esm_templateObject || (growth_design_system_components_countryList_esm_templateObject = (0,taggedTemplateLiteralLoose_7a042257_esm._)(["\n\tflex-shrink: 0;\n\tmargin-left: 20px;\n\tdisplay: flex;\n\tbackground: url('https://go-assets.ibcdn.com/u/GI/images/1720417477097-country-flags-sprite.png') no-repeat;\n\tbackground-size: 100% 49494%;\n\twidth: 23px;\n\theight: 17px;\n\n\t&.ch,\n\t&.np {\n\t\tbox-shadow: none !important;\n\t}\n\n\t&.dz {\n\t\tbackground-position: center 0.2287%;\n\t}\n\n\t&.ao {\n\t\tbackground-position: center 0.4524%;\n\t}\n    \n    &.aq {\n        background-position: center 53.21%;\n    }\n\n    &.an {\n        background-position: center 53.65%;\n    }\n\n\t&.bj {\n\t\tbackground-position: center 0.6721%;\n\t}\n\n\t&.bw {\n\t\tbackground-position: center 0.8958%;\n\t}\n\n\t&.bf {\n\t\tbackground-position: center 1.1162%;\n\t}\n\n\t&.bi {\n\t\tbackground-position: center 1.3379%;\n\t}\n\n\t&.cm {\n\t\tbackground-position: center 1.5589%;\n\t}\n\n\t&.cv {\n\t\tbackground-position: center 1.7805%;\n\t}\n\n\t&.cf {\n\t\tbackground-position: center 2.0047%;\n\t}\n\n\t&.td {\n\t\tbackground-position: center 2.2247%;\n\t}\n\n\t&.cd {\n\t\tbackground-position: left 2.4467%;\n\t}\n\n\t&.dj {\n\t\tbackground-position: left 2.6674%;\n\t}\n\n\t&.eg {\n\t\tbackground-position: center 2.8931%;\n\t}\n\n\t&.gq {\n\t\tbackground-position: center 3.1125%;\n\t}\n\n\t&.er {\n\t\tbackground-position: left 3.3325%;\n\t}\n\n\t&.et {\n\t\tbackground-position: center 3.5542%;\n\t}\n\n\t&.ga {\n\t\tbackground-position: center 3.7759%;\n\t}\n\n\t&.gm {\n\t\tbackground-position: center 4.0015%;\n\t}\n\n\t&.gh {\n\t\tbackground-position: center 4.2229%;\n\t}\n\n\t&.gn {\n\t\tbackground-position: center 4.441%;\n\t}\n\n\t&.gw {\n\t\tbackground-position: left 4.66663%;\n\t}\n\n\t&.ci {\n\t\tbackground-position: center 4.8844%;\n\t}\n\n\t&.ke {\n\t\tbackground-position: center 5.1061%;\n\t}\n\n\t&.ls {\n\t\tbackground-position: center 5.3298%;\n\t}\n\n\t&.lr {\n\t\tbackground-position: left 5.5495%;\n\t}\n\n\t&.ly {\n\t\tbackground-position: center 5.7712%;\n\t}\n\n\t&.mg {\n\t\tbackground-position: center 5.994%;\n\t}\n\n\t&.mw {\n\t\tbackground-position: center 6.2156%;\n\t}\n\n\t&.ml {\n\t\tbackground-position: center 6.4363%;\n\t}\n\n\t&.mr {\n\t\tbackground-position: center 6.658%;\n\t}\n\n\t&.mu {\n\t\tbackground-position: center 6.8805%;\n\t}\n\n\t&.yt {\n\t\tbackground-position: center 7.1038%;\n\t}\n\n\t&.ma {\n\t\tbackground-position: center 7.3231%;\n\t}\n\n\t&.mz {\n\t\tbackground-position: left 7.5448%;\n\t}\n\n\t&.na {\n\t\tbackground-position: left 7.7661%;\n\t}\n\n\t&.ne {\n\t\tbackground-position: center 7.98937%;\n\t}\n\n\t&.ng {\n\t\tbackground-position: center 8.2099%;\n\t}\n\n\t&.cg {\n\t\tbackground-position: center 8.4316%;\n\t}\n\n\t&.re {\n\t\tbackground-position: center 8.6533%;\n\t}\n\n\t&.rw {\n\t\tbackground-position: right 8.875%;\n\t}\n\n\t&.sh {\n\t\tbackground-position: center 9.0967%;\n\t}\n\n\t&.st {\n\t\tbackground-position: center 9.32237%;\n\t}\n\n\t&.sn {\n\t\tbackground-position: center 9.5426%;\n\t}\n\n\t&.sc {\n\t\tbackground-position: left 9.7628%;\n\t}\n\n\t&.sl {\n\t\tbackground-position: center 9.9845%;\n\t}\n\n\t&.so {\n\t\tbackground-position: center 10.2052%;\n\t}\n\n\t&.za {\n\t\tbackground-position: left 10.4269%;\n\t}\n\n\t&.ss {\n\t\tbackground-position: left 10.6486%;\n\t}\n\n\t&.sd {\n\t\tbackground-position: center 10.8703%;\n\t}\n\n\t&.sr {\n\t\tbackground-position: center 11.0945%;\n\t}\n\n\t&.sz {\n\t\tbackground-position: center 11.3135%;\n\t}\n\n\t&.tg {\n\t\tbackground-position: left 11.5354%;\n\t}\n\n\t&.tn {\n\t\tbackground-position: center 11.7593%;\n\t}\n\n\t&.ug {\n\t\tbackground-position: center 11.9799%;\n\t}\n\n\t&.tz {\n\t\tbackground-position: center 12.2005%;\n\t}\n\n\t&.eh {\n\t\tbackground-position: center 12.4222%;\n\t}\n\n\t&.ye {\n\t\tbackground-position: center 12.644%;\n\t}\n\n\t&.zm {\n\t\tbackground-position: center 12.8664%;\n\t}\n\n\t&.zw {\n\t\tbackground-position: left 13.0873%;\n\t}\n\n\t&.ai {\n\t\tbackground-position: center 13.309%;\n\t}\n\n\t&.ag {\n\t\tbackground-position: center 13.5307%;\n\t}\n\n\t&.ar {\n\t\tbackground-position: center 13.7524%;\n\t}\n\n\t&.aw {\n\t\tbackground-position: left 13.9741%;\n\t}\n\n\t&.bs {\n\t\tbackground-position: left 14.1958%;\n\t}\n\n\t&.bb {\n\t\tbackground-position: center 14.4175%;\n\t}\n\n\t&.bq {\n\t\tbackground-position: center 14.6415%;\n\t}\n\n\t&.bz {\n\t\tbackground-position: center 14.8609%;\n\t}\n\n\t&.bm {\n\t\tbackground-position: center 15.0826%;\n\t}\n\n\t&.bo {\n\t\tbackground-position: center 15.306%;\n\t}\n\n\t&.vg {\n\t\tbackground-position: center 15.528%;\n\t}\n\n\t&.br {\n\t\tbackground-position: center 15.7496%;\n\t}\n\n\t&.ca {\n\t\tbackground-position: center 15.9694%;\n\t}\n\n\t&.ky {\n\t\tbackground-position: center 16.1911%;\n\t}\n\n\t&.cl {\n\t\tbackground-position: left 16.4128%;\n\t}\n\n\t&.co {\n\t\tbackground-position: left 16.6345%;\n\t}\n\n\t&.km {\n\t\tbackground-position: center 16.8562%;\n\t}\n\n\t&.cr {\n\t\tbackground-position: center 17.0779%;\n\t}\n\n\t&.cu {\n\t\tbackground-position: left 17.2996%;\n\t}\n\n\t&.cw {\n\t\tbackground-position: center 17.5213%;\n\t}\n\n\t&.dm {\n\t\tbackground-position: center 17.743%;\n\t}\n\n\t&.do {\n\t\tbackground-position: center 17.968%;\n\t}\n\n\t&.ec {\n\t\tbackground-position: center 18.1864%;\n\t}\n\n\t&.sv {\n\t\tbackground-position: center 18.4081%;\n\t}\n\n\t&.fk {\n\t\tbackground-position: center 18.6298%;\n\t}\n\n\t&.gf {\n\t\tbackground-position: center 18.8515%;\n\t}\n\n\t&.gl {\n\t\tbackground-position: left 19.0732%;\n\t}\n\n\t&.gd {\n\t\tbackground-position: center 19.2987%;\n\t}\n\n\t&.gp {\n\t\tbackground-position: center 19.518%;\n\t}\n\n\t&.gt {\n\t\tbackground-position: center 19.7383%;\n\t}\n\n\t&.gy {\n\t\tbackground-position: center 19.96%;\n\t}\n\n\t&.ht {\n\t\tbackground-position: center 20.1817%;\n\t}\n\n\t&.hn {\n\t\tbackground-position: center 20.4034%;\n\t}\n\n\t&.jm {\n\t\tbackground-position: center 20.6241%;\n\t}\n\n\t&.mq {\n\t\tbackground-position: center 20.8468%;\n\t}\n\n\t&.mx {\n\t\tbackground-position: center 21.0685%;\n\t}\n\n\t&.ms {\n\t\tbackground-position: center 21.2902%;\n\t}\n\n\t&.ni {\n\t\tbackground-position: center 21.5119%;\n\t}\n\n\t&.pa {\n\t\tbackground-position: center 21.7336%;\n\t}\n\n\t&.py {\n\t\tbackground-position: center 21.9553%;\n\t}\n\n\t&.pe {\n\t\tbackground-position: center 22.177%;\n\t}\n\n\t&.pr {\n\t\tbackground-position: left 22.4002%;\n\t}\n\n\t&.bl {\n\t\tbackground-position: center 22.6204%;\n\t}\n\n\t&.kn {\n\t\tbackground-position: center 22.8421%;\n\t}\n\n\t&.lc {\n\t\tbackground-position: center 23.0638%;\n\t}\n\n\t&.pm {\n\t\tbackground-position: center 23.2855%;\n\t}\n\n\t&.vc {\n\t\tbackground-position: center 23.5072%;\n\t}\n\n\t&.sx {\n\t\tbackground-position: left 23.732%;\n\t}\n\n\t&.tt {\n\t\tbackground-position: center 23.9506%;\n\t}\n\n\t&.tc {\n\t\tbackground-position: center 24.1723%;\n\t}\n\n\t&.us {\n\t\tbackground-position: center 24.394%;\n\t}\n\n\t&.vi {\n\t\tbackground-position: center 24.6157%;\n\t}\n\n\t&.uy {\n\t\tbackground-position: left 24.8374%;\n\t}\n\n\t&.ve {\n\t\tbackground-position: center 25.0591%;\n\t}\n\n\t&.ab {\n\t\tbackground-position: center 25.279%;\n\t}\n\n\t&.af {\n\t\tbackground-position: center 25.5025%;\n\t}\n\n\t&.az {\n\t\tbackground-position: center 25.7242%;\n\t}\n\n\t&.bd {\n\t\tbackground-position: center 25.9459%;\n\t}\n\n\t&.bt {\n\t\tbackground-position: center 26.1676%;\n\t}\n\n\t&.bn {\n\t\tbackground-position: center 26.3885%;\n\t}\n\n\t&.kh {\n\t\tbackground-position: center 26.611%;\n\t}\n\n\t&.cn {\n\t\tbackground-position: left 26.8327%;\n\t}\n\n\t&.ge {\n\t\tbackground-position: center 27.0544%;\n\t}\n\n\t&.hk {\n\t\tbackground-position: center 27.2761%;\n\t}\n\n\t&.in {\n\t\tbackground-position: center 27.4978%;\n\t}\n\n\t&.id {\n\t\tbackground-position: center 27.7195%;\n\t}\n\n\t&.jp {\n\t\tbackground-position: center 27.9412%;\n\t}\n\n\t&.kz {\n\t\tbackground-position: center 28.1615%;\n\t}\n\n\t&.la {\n\t\tbackground-position: center 28.3846%;\n\t}\n\n\t&.mo {\n\t\tbackground-position: center 28.6063%;\n\t}\n\n\t&.my {\n\t\tbackground-position: center 28.829%;\n\t}\n\n\t&.mv {\n\t\tbackground-position: center 29.0497%;\n\t}\n\n\t&.mn {\n\t\tbackground-position: left 29.2714%;\n\t}\n\n\t&.mm {\n\t\tbackground-position: center 29.4931%;\n\t}\n\n\t&.np {\n\t\tbackground-position: left 29.7148%;\n\t}\n\n\t&.kp {\n\t\tbackground-position: left 29.9365%;\n\t}\n\n\t&.mp {\n\t\tbackground-position: center 30.1582%;\n\t}\n\n\t&.pw {\n\t\tbackground-position: center 30.3799%;\n\t}\n\n\t&.pg {\n\t\tbackground-position: center 30.6016%;\n\t}\n\n\t&.ph {\n\t\tbackground-position: left 30.8233%;\n\t}\n\n\t&.sg {\n\t\tbackground-position: left 31.045%;\n\t}\n\n\t&.kr {\n\t\tbackground-position: center 31.2667%;\n\t}\n\n\t&.lk {\n\t\tbackground-position: right 31.4884%;\n\t}\n\n\t&.tw {\n\t\tbackground-position: left 31.7101%;\n\t}\n\n\t&.tj {\n\t\tbackground-position: center 31.9318%;\n\t}\n\n\t&.th {\n\t\tbackground-position: center 32.1535%;\n\t}\n\n\t&.tl {\n\t\tbackground-position: left 32.3752%;\n\t}\n\n\t&.tm {\n\t\tbackground-position: center 32.5969%;\n\t}\n\n\t&.vn {\n\t\tbackground-position: center 32.8186%;\n\t}\n\n\t&.al {\n\t\tbackground-position: center 33.0403%;\n\t}\n\n\t&.ad {\n\t\tbackground-position: center 33.25975%;\n\t}\n\n\t&.am {\n\t\tbackground-position: center 33.4837%;\n\t}\n\n\t&.at {\n\t\tbackground-position: center 33.7054%;\n\t}\n\n\t&.by {\n\t\tbackground-position: left 33.9271%;\n\t}\n\n\t&.be {\n\t\tbackground-position: center 34.1488%;\n\t}\n\n\t&.ba {\n\t\tbackground-position: center 34.3705%;\n\t}\n\n\t&.bg {\n\t\tbackground-position: center 34.5922%;\n\t}\n\n\t&.hr {\n\t\tbackground-position: center 34.8139%;\n\t}\n\n\t&.cy {\n\t\tbackground-position: center 35.0356%;\n\t}\n\n\t&.cz {\n\t\tbackground-position: left 35.2555%;\n\t}\n\n\t&.dk {\n\t\tbackground-position: center 35.479%;\n\t}\n\n\t&.ee {\n\t\tbackground-position: center 35.7007%;\n\t}\n\n\t&.fo {\n\t\tbackground-position: center 35.9224%;\n\t}\n\n\t&.fi {\n\t\tbackground-position: center 36.1441%;\n\t}\n\n\t&.fr {\n\t\tbackground-position: center 36.3658%;\n\t}\n\n\t&.de {\n\t\tbackground-position: center 36.5875%;\n\t}\n\n\t&.gi {\n\t\tbackground-position: center 36.8092%;\n\t}\n\n\t&.gr {\n\t\tbackground-position: left 37.0309%;\n\t}\n\n\t&.hu {\n\t\tbackground-position: center 37.2526%;\n\t}\n\n\t&.is {\n\t\tbackground-position: center 37.4743%;\n\t}\n\n\t&.ie {\n\t\tbackground-position: center 37.696%;\n\t}\n\n\t&.im {\n\t\tbackground-position: center 37.9177%;\n\t}\n\n\t&.it {\n\t\tbackground-position: center 38.1394%;\n\t}\n\n\t&.je {\n\t\tbackground-position: center 38.3611%;\n\t}\n\n\t&.xk {\n\t\tbackground-position: center 38.5828%;\n\t}\n\n\t&.lv {\n\t\tbackground-position: center 38.8045%;\n\t}\n\n\t&.li {\n\t\tbackground-position: left 39.0262%;\n\t}\n\n\t&.lt {\n\t\tbackground-position: center 39.2479%;\n\t}\n\n\t&.lu {\n\t\tbackground-position: center 39.4696%;\n\t}\n\n\t&.mt {\n\t\tbackground-position: left 39.6913%;\n\t}\n\n\t&.md {\n\t\tbackground-position: center 39.913%;\n\t}\n\n\t&.mc {\n\t\tbackground-position: center 40.1347%;\n\t}\n\n\t&.me {\n\t\tbackground-position: center 40.3564%;\n\t}\n\n\t&.nl {\n\t\tbackground-position: center 40.5781%;\n\t}\n\n\t&.mk {\n\t\tbackground-position: center 40.7998%;\n\t}\n\n\t&.no {\n\t\tbackground-position: center 41.0215%;\n\t}\n\n\t&.pl {\n\t\tbackground-position: center 41.2432%;\n\t}\n\n\t&.pt {\n\t\tbackground-position: center 41.4649%;\n\t}\n\n\t&.ro {\n\t\tbackground-position: center 41.6866%;\n\t}\n\n\t&.ru {\n\t\tbackground-position: center 41.9083%;\n\t}\n\n\t&.sm {\n\t\tbackground-position: center 42.13%;\n\t}\n\t&.rs {\n\t\tbackground-position: center 42.3517%;\n\t}\n\t&.sk {\n\t\tbackground-position: center 42.5734%;\n\t}\n\t&.si {\n\t\tbackground-position: center 42.7951%;\n\t}\n\t&.es {\n\t\tbackground-position: left 43.0168%;\n\t}\n\t&.se {\n\t\tbackground-position: center 43.2385%;\n\t}\n\t&.ch {\n\t\tbackground-position: center 43.4602%;\n\t}\n\t&.tr {\n\t\tbackground-position: center 43.6819%;\n\t}\n\t&.ua {\n\t\tbackground-position: center 43.9036%;\n\t}\n\t&.gb {\n\t\tbackground-position: center 44.1253%;\n\t}\n    &.uk {\n        background-position: center 44.1253%;\n    }\n\t&.va {\n\t\tbackground-position: right 44.347%;\n\t}\n\t&.bh {\n\t\tbackground-position: center 44.5687%;\n\t}\n\t&.ir {\n\t\tbackground-position: center 44.7904%;\n\t}\n\t&.iq {\n\t\tbackground-position: center 45.0121%;\n\t}\n\t&.il {\n\t\tbackground-position: center 45.2338%;\n\t}\n\t&.kw {\n\t\tbackground-position: left 45.4555%;\n\t}\n\t&.jo {\n\t\tbackground-position: left 45.6772%;\n\t}\n\t&.kg {\n\t\tbackground-position: center 45.897%;\n\t}\n\t&.lb {\n\t\tbackground-position: center 46.1206%;\n\t}\n\t&.om {\n\t\tbackground-position: left 46.3423%;\n\t}\n\t&.pk {\n\t\tbackground-position: center 46.561%;\n\t}\n\t&.ps {\n\t\tbackground-position: center 46.7857%;\n\t}\n\t&.qa {\n\t\tbackground-position: center 47.0074%;\n\t}\n\t&.sa {\n\t\tbackground-position: center 47.2291%;\n\t}\n\t&.sy {\n\t\tbackground-position: center 47.4508%;\n\t}\n\t&.ae {\n\t\tbackground-position: center 47.6725%;\n\t}\n\t&.uz {\n\t\tbackground-position: left 47.8942%;\n\t}\n\t&.as {\n\t\tbackground-position: right 48.1159%;\n\t}\n\t&.au {\n\t\tbackground-position: center 48.3376%;\n\t}\n\t&.cx {\n\t\tbackground-position: center 48.5593%;\n\t}\n\t&.cc {\n\t\tbackground-position: center 48.781%;\n\t}\n\t&.ck {\n\t\tbackground-position: center 49.002%;\n\t}\n\t&.fj {\n\t\tbackground-position: center 49.2244%;\n\t}\n\t&.pf {\n\t\tbackground-position: center 49.4445%;\n\t}\n\t&.gu {\n\t\tbackground-position: center 49.6678%;\n\t}\n\t&.ki {\n\t\tbackground-position: center 49.8895%;\n\t}\n\t&.mh {\n\t\tbackground-position: left 50.1112%;\n\t}\n\t&.fm {\n\t\tbackground-position: center 50.3329%;\n\t}\n\t&.nc {\n\t\tbackground-position: center 50.5546%;\n\t}\n\t&.nz {\n\t\tbackground-position: center 50.7763%;\n\t}\n\t&.nr {\n\t\tbackground-position: left 50.998%;\n\t}\n\t&.nu {\n\t\tbackground-position: center 51.2197%;\n\t}\n\t&.nf {\n\t\tbackground-position: center 51.4414%;\n\t}\n\t&.ws {\n\t\tbackground-position: left 51.6631%;\n\t}\n\t&.sb {\n\t\tbackground-position: left 51.8848%;\n\t}\n\t&.tk {\n\t\tbackground-position: center 52.1065%;\n\t}\n\t&.to {\n\t\tbackground-position: left 52.3282%;\n\t}\n\t&.tv {\n\t\tbackground-position: center 52.5499%;\n\t}\n\t&.vu {\n\t\tbackground-position: left 52.7716%;\n\t}\n\t&.wf {\n\t\tbackground-position: center 52.9933%;\n\t}\n"])));

var CountryImg = function CountryImg(_ref) {
  var countryCode = _ref.countryCode;
  return /*#__PURE__*/react.createElement(CountryImg$1, {
    className: "cntryFlgImg " + countryCode
  });
};



// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/visitor-id/dist/helper-bc63c3dd.esm.js
// constant
var helper_bc63c3dd_esm_C = {
  CookieName: '__gi_vid',
  MaxAgeDay: 365,
  // 1 year
  Domain: '.goibibo.com'
}; // vid generator function

var generateVid = function generateVid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint-disable-next-line no-bitwise */
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    /* eslint-disable-next-line no-bitwise */

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js




function visitorIdBrowser(options) {
  var opts = options || {}; // if vid cookie is present

  if ((0,growth_cookies_esm/* getItem */.rV)(helper_bc63c3dd_esm_C.CookieName)) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return true;
  } // if vid is not present in cookie


  var vid = generateVid();
  (0,growth_cookies_esm/* setItem */.LS)(helper_bc63c3dd_esm_C.CookieName, vid, {
    expires: helper_bc63c3dd_esm_C.MaxAgeDay * 24 * 60 * 60,
    path: "/",
    domain: helper_bc63c3dd_esm_C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return true;
}

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = getItem(C.CookieName);
  return vid || undefined;
};



// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(40624);
// EXTERNAL MODULE: ../../node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(44607);
// EXTERNAL MODULE: ../../node_modules/@growth/tooltip/dist/growth-tooltip.esm.js
var growth_tooltip_esm = __webpack_require__(87792);
;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/node_modules/@growth/custom-hooks/useDebounce/dist/growth-custom-hooks-useDebounce.esm.js


var useDebounce = function useDebounce(callback, input, timer) {
  (0,react.useEffect)(function () {
    var timeoutHandler = setTimeout(function () {
      if (callback) callback();
    }, timer);
    return function () {
      if (timeoutHandler) clearTimeout(timeoutHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input, timer]);
};



;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/node_modules/@growth/custom-hooks/useOutsideHandler/dist/growth-custom-hooks-useOutsideHandler.esm.js


var useOutsideHandler = function useOutsideHandler(_ref) {
  var eventName = _ref.eventName,
    ref = _ref.ref,
    callback = _ref.callback;
  var handleEvent = function handleEvent(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };
  (0,react.useEffect)(function () {
    document.addEventListener(eventName, handleEvent);
    return function () {
      document.removeEventListener(eventName, handleEvent);
    };
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/dist/index-1b1e128d.esm.js





var _templateObject$2, _templateObject2$2, _templateObject3$1, _templateObject4$1;
var SearchItem$1 = styled_components_browser_esm/* default.li */.ZP.li(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-shrink: 0;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcursor: pointer;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\theight: ", ";\n\tbackground: ", ";\n\n\t&:hover {\n\t\tbackground: #eef4fd;\n\t}\n"])), function (_ref) {
  var isMWeb = _ref.isMWeb;
  return isMWeb ? '16px' : '12px';
}, function (_ref2) {
  var isMWeb = _ref2.isMWeb;
  return isMWeb ? '16px' : '12px';
}, function (_ref3) {
  var isMWeb = _ref3.isMWeb;
  return isMWeb ? '32px' : '44px';
}, function (_ref4) {
  var isSelected = _ref4.isSelected;
  return isSelected ? '#eef4fd' : 'transparent';
});
var LocationWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n"])));
var IconWrapper = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n\tbackground: #f4f4f4;\n\tborder-radius: 4px;\n\twidth: ", ";\n\theight: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 12px;\n"])), function (_ref5) {
  var isMWeb = _ref5.isMWeb;
  return isMWeb ? '32px' : '44px';
}, function (_ref6) {
  var isMWeb = _ref6.isMWeb;
  return isMWeb ? '32px' : '44px';
});
var LocationName = styled_components_browser_esm/* default.span */.ZP.span(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #222222;\n\tline-height: 19px;\n"])), dist_growth_design_system_esm/* textSizes.MediumW1 */.iH.MediumW1);

var SearchItem = function SearchItem(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    name = _ref.name,
    itemClickHandler = _ref.itemClickHandler,
    isSelected = _ref.isSelected,
    isMWeb = _ref.isMWeb,
    className = _ref.className,
    countryCode = _ref.countryCode,
    countryName = _ref.countryName;
  return /*#__PURE__*/react.createElement(SearchItem$1, {
    className: className,
    isMWeb: isMWeb,
    isSelected: isSelected,
    onClick: function onClick() {
      return itemClickHandler({
        id: id,
        name: name,
        countryCode: countryCode,
        countryName: countryName
      });
    }
  }, /*#__PURE__*/react.createElement(LocationWrapper, null, /*#__PURE__*/react.createElement(IconWrapper, {
    isMWeb: isMWeb
  }, icon), /*#__PURE__*/react.createElement(LocationName, null, name)));
};
SearchItem.defaultProps = {
  isSelected: false,
  className: ''
};

var index_1b1e128d_esm_templateObject$1, _templateObject2$1, index_1b1e128d_esm_templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var SearchBoxContainer = styled_components_browser_esm/* default.div */.ZP.div(index_1b1e128d_esm_templateObject$1 || (index_1b1e128d_esm_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tpadding: 16px;\n"])));
var SearchResultContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tpadding: ", ";\n"])), function (prop) {
  return prop.isMWeb ? '#f4f4f4;' : '#ffffff';
}, function (prop) {
  return prop.isMWeb ? '0 16px 16px' : '0 16px 16px 16px';
});
var SearchResultListContainer = styled_components_browser_esm/* default.div */.ZP.div(index_1b1e128d_esm_templateObject3 || (index_1b1e128d_esm_templateObject3 = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tbackground-color: #ffffff;\n\n\t& .firstItem {\n\t\tmargin-top: 0;\n\t}\n\n\t& .lastItem {\n\t\tmargin-bottom: 0;\n\t}\n"])), function (prop) {
  return prop.isMWeb ? '12px' : '0';
}, function (prop) {
  return prop.isMWeb ? '4px' : '0';
});
styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 22px;\n\tbackground-repeat: no-repeat;\n\theight: 18px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.636 2.637a9.005 9.005 0 0 1 12.73-.004 9.013 9.013 0 0 1 0 12.734 9.005 9.005 0 0 1-12.73-.004 8.998 8.998 0 0 1 0-12.726Zm9.867 9.854a.75.75 0 0 0 .027-1.03l-2.335-2.334a.188.188 0 0 1 0-.264l2.335-2.334a.75.75 0 1 0-1.062-1.062L9.134 7.801a.188.188 0 0 1-.266 0L6.534 5.467A.75.75 0 0 0 5.476 6.53L7.81 8.863a.187.187 0 0 1 0 .264L5.476 11.46a.75.75 0 0 0 0 1.062.765.765 0 0 0 1.062 0l2.334-2.334a.19.19 0 0 1 .266 0l2.334 2.334a.75.75 0 0 0 1.031-.03Z' fill='%23777'/%3E%3C/svg%3E\");\n"])));
var MapIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 14px;\n\tbackground-repeat: no-repeat;\n\theight: 18px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='14' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6.923A6.93 6.93 0 0 1 6.923 0a6.931 6.931 0 0 1 6.922 6.923c0 4.39-6.17 10.61-6.432 10.874a.692.692 0 0 1-.98 0C6.17 17.534 0 11.313 0 6.923Zm4.499 0a2.423 2.423 0 1 0 4.846 0 2.423 2.423 0 0 0-4.846 0Z' fill='%23647A97'/%3E%3C/svg%3E\");\n"])));
var HorizontalLine = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\t\theight: 1px;\n\t\tbackground-color: #e4e4e4;\n\t\tmargin: ", ";\n"])), function (prop) {
  return prop.gapping || "0";
});
var SearchResultHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #717171;\n\tpadding: 16px 0;\n"])), dist_growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var NoResultFound = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #717171;\n\tpadding: 20px 0 12px 0px;\n\ttext-align: center;\n"])), dist_growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);

var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "#B0B0B0",
    height: "1.6rem",
    width: "1.6rem",
    className: "HappySearchIcon-sc-9cg8c3-0 kWKCFW"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m15.61 13.731-3.095-3.096a6.84 6.84 0 0 0-1.348-9.084 6.83 6.83 0 0 0-9.166.452 6.84 6.84 0 0 0-.449 9.172 6.83 6.83 0 0 0 9.079 1.346l3.095 3.095c.524.512 1.36.512 1.884 0 .52-.52.52-1.364 0-1.885M6.84 2.008a4.83 4.83 0 0 1 4.83 4.833 4.831 4.831 0 1 1-9.661 0 4.837 4.837 0 0 1 4.83-4.833z"
  }));
};

var index_1b1e128d_esm_templateObject, index_1b1e128d_esm_templateObject2;
var StyledInputFieldContainer = styled_components_browser_esm/* default.div */.ZP.div(index_1b1e128d_esm_templateObject || (index_1b1e128d_esm_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n\tpadding: 14px;\n  border-radius: 4px;\n  border: solid 1px;\n  background-color: #fff;\n\tborder-color: ", ";\n\n"])), function (props) {
  return props.hasFocus ? '#2276e3' : '#e4e4e4';
});
var StyledInput = styled_components_browser_esm/* default.input */.ZP.input(index_1b1e128d_esm_templateObject2 || (index_1b1e128d_esm_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tfont-family: Rubik;\n\t", ";\n\tborder: none;\n\tcolor: #222;\n\tpadding-right: 8px;\n\theight: 26px;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&::placeholder {\n\t\tcolor: #717171;\n\t\theight: 17px;\n\t\t", ";\n\t}\n"])), dist_growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2, dist_growth_design_system_esm/* textSizes.BaseW1 */.iH.BaseW1);

function index_1b1e128d_esm_InputField(props) {
  var inputName = props.inputName,
    inputClassName = props.inputClassName,
    onChange = props.onChange,
    inputType = props.inputType,
    maxlength = props.maxlength,
    autoFocus = props.autoFocus,
    placeholder = props.placeholder,
    inputVal = props.inputVal,
    inputDisabled = props.inputDisabled,
    Icon = props.rightIconComp,
    showIcon = props.showIcon;
  var _useState = (0,react.useState)(inputVal),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = (0,react.useState)(false),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  var handleInputChange = function handleInputChange(e) {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };
  return /*#__PURE__*/react.createElement(StyledInputFieldContainer, {
    hasFocus: hasFocus
  }, /*#__PURE__*/react.createElement(StyledInput, {
    className: inputClassName,
    onChange: handleInputChange,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: value,
    disabled: inputDisabled,
    onFocus: function onFocus() {
      return setHasFocus(true);
    },
    onBlur: function onBlur() {
      return setHasFocus(false);
    }
  }), !value && showIcon && Icon && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Icon, null)));
}
index_1b1e128d_esm_InputField.defaultProps = {
  inputName: '',
  inputClassName: '',
  onChange: function onChange() {},
  inputType: 'text',
  maxlength: 255,
  autoFocus: true,
  placeholder: 'Enter text',
  inputVal: '',
  inputDisabled: false,
  rightIconComp: SearchIcon,
  showIcon: true
};

function SearchResultMenu(props) {
  var options = props.options,
    _props$selectedID = props.selectedID,
    selectedID = _props$selectedID === void 0 ? '' : _props$selectedID,
    handleOptionSelected = props.handleOptionSelected,
    handleSearch = props.handleSearch,
    _props$isMWeb = props.isMWeb,
    isMWeb = _props$isMWeb === void 0 ? false : _props$isMWeb,
    inputPlaceholder = props.inputPlaceholder,
    selectedValue = props.selectedValue,
    error = props.error;
  var getClassName = function getClassName(index, length) {
    if (index === 0) {
      return 'firstItem';
    }
    if (index === length - 1) {
      return 'lastItem';
    }
    return '';
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(SearchBoxContainer, null, /*#__PURE__*/react.createElement(index_1b1e128d_esm_InputField, {
    onChange: function onChange(e) {
      return handleSearch(e.target.value);
    },
    placeholder: inputPlaceholder,
    inputVal: selectedValue
  })), !isMWeb && /*#__PURE__*/react.createElement(HorizontalLine, {
    gapping: "0 16px"
  }), /*#__PURE__*/react.createElement(SearchResultContainer, {
    isMWeb: isMWeb
  }, (options == null ? void 0 : options.length) > 0 ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(SearchResultHeading, null, "SEARCH RESULTS"), /*#__PURE__*/react.createElement(SearchResultListContainer, {
    isMWeb: isMWeb
  }, options.map(function (item, index) {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(SearchItem, {
      itemClickHandler: function itemClickHandler(selectedOption) {
        return handleOptionSelected(selectedOption);
      },
      icon: /*#__PURE__*/react.createElement(MapIcon, null),
      key: item.id,
      id: item.id,
      name: item.name,
      countryCode: item.countryCode,
      countryName: item.countryName,
      isSelected: selectedID === item.id,
      isMWeb: isMWeb,
      className: getClassName(index, options.length)
    }), isMWeb && index < options.length - 1 && /*#__PURE__*/react.createElement(HorizontalLine, null));
  }))) : /*#__PURE__*/react.createElement(NoResultFound, null, error || "Sorry, No results found")));
}
SearchResultMenu.defaultProps = {
  isMWeb: false,
  selectedValue: '',
  error: undefined
};



;// CONCATENATED MODULE: ../../node_modules/@growth/form-controls/cityDropdown/dweb/dist/growth-form-controls-cityDropdown-dweb.esm.js








var growth_form_controls_cityDropdown_dweb_esm_templateObject, growth_form_controls_cityDropdown_dweb_esm_templateObject2, growth_form_controls_cityDropdown_dweb_esm_templateObject3, growth_form_controls_cityDropdown_dweb_esm_templateObject4, growth_form_controls_cityDropdown_dweb_esm_templateObject5;
var DropdownContainer = styled_components_browser_esm/* default.div */.ZP.div(growth_form_controls_cityDropdown_dweb_esm_templateObject || (growth_form_controls_cityDropdown_dweb_esm_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"])));
var growth_form_controls_cityDropdown_dweb_esm_Dropdown = styled_components_browser_esm/* default.div */.ZP.div(growth_form_controls_cityDropdown_dweb_esm_templateObject2 || (growth_form_controls_cityDropdown_dweb_esm_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 58px;\n\tpadding: 18px 14px;\n\tfont-weight: 700;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n\tposition: relative;\n\tcursor: pointer;\n\t", "\n\t&::after {\n\t\tcontent: '';\n\t\tborder: solid #647a97;\n\t\tdisplay: inline-flex;\n\t\tborder-width: 0 2px 2px 0;\n\t\tpadding: 4px;\n\t\ttransform: ", ";\n\t\tposition: absolute;\n\t\tright: 17px;\n\t\ttop: 22px;\n\t}\n"])), function (p) {
  return p.isActive && "\n    border-color: #2276E3;\n  ";
}, function (props) {
  return props.isActive ? "rotate(225deg)" : "rotate(45deg)";
});
var SelectLabel = styled_components_browser_esm/* default.label */.ZP.label(growth_form_controls_cityDropdown_dweb_esm_templateObject3 || (growth_form_controls_cityDropdown_dweb_esm_templateObject3 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 19px;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #717171;\n\tfont-weight: 500;\n\ttransition: all 0.3s ease-in-out;\n\t", "\n"])), function (p) {
  return p.isSelected && "\n    left: 14px;\n    top: -11px;\n    font-size: 12px;\n    font-weight: 400;\n    background: #fff;\n    padding: 0 4px;\n  ";
});
var SelectedOption = styled_components_browser_esm/* default.p */.ZP.p(growth_form_controls_cityDropdown_dweb_esm_templateObject4 || (growth_form_controls_cityDropdown_dweb_esm_templateObject4 = _taggedTemplateLiteralLoose(["\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tfont-weight: 500;\n"])));
var OptionList = styled_components_browser_esm/* default.div */.ZP.div(growth_form_controls_cityDropdown_dweb_esm_templateObject5 || (growth_form_controls_cityDropdown_dweb_esm_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground-color: #fff;\n\tbox-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n\tborder-radius: 4px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 58px;\n\tz-index: 2;\n\tmax-height: 200px;\n\toverflow-y: auto;\n"])));

function CityDropdown(props) {
  var fetchOptions = props.fetchOptions,
    onCitySelect = props.onCitySelect,
    _props$options = props.options,
    defaultOptions = _props$options === void 0 ? [] : _props$options,
    _props$defaultSelcted = props.defaultSelctedId,
    defaultSelctedId = _props$defaultSelcted === void 0 ? '' : _props$defaultSelcted,
    searchPlaceholder = props.searchPlaceholder,
    customStyles = props.customStyles;
  var _ref = customStyles || {},
    root = _ref.root,
    listContainer = _ref.listContainer;
  var _useState = (0,react.useState)(''),
    searchString = _useState[0],
    setSearchString = _useState[1];
  var _useState2 = (0,react.useState)([]),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = (0,react.useState)({
      id: '',
      name: ''
    }),
    selectedCity = _useState3[0],
    setSelectedCity = _useState3[1];
  var _useState4 = (0,react.useState)(),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    showOptions = _useState5[0],
    setShowOptions = _useState5[1];
  var dropdownContainerRef = (0,react.useRef)();
  var fetchOptionsDebounced = function fetchOptionsDebounced() {
    fetchOptions(searchString).then(function (res) {
      var parsedOptions = res.map(function (item) {
        return {
          name: item.displayName,
          id: item.cityCode,
          countryCode: item.countryCode,
          countryName: item.countryName
        };
      });
      setError(undefined);
      setOptions(parsedOptions);
    })["catch"](function (err) {
      setOptions([]);
      setError("Something went wrong, please try again.");
    });
  };
  var citySelectHandler = function citySelectHandler(city) {
    setSelectedCity({
      id: city.id,
      name: city.name
    });
    setShowOptions(false);
    onCitySelect == null || onCitySelect(city);
  };
  (0,react.useEffect)(function () {
    if ((defaultOptions == null ? void 0 : defaultOptions.length) > 0) {
      var _defaultOptions$;
      setOptions(defaultOptions);
      setSelectedCity({
        id: defaultSelctedId,
        name: (_defaultOptions$ = defaultOptions[0]) == null ? void 0 : _defaultOptions$.name
      });
    }
  }, [defaultOptions, defaultSelctedId]);
  useDebounce(fetchOptionsDebounced, searchString, 400);
  useOutsideHandler({
    eventName: 'click',
    ref: dropdownContainerRef,
    callback: function callback() {
      if (showOptions) setShowOptions(false);
    }
  });
  return /*#__PURE__*/react.createElement(DropdownContainer, {
    ref: dropdownContainerRef,
    style: root
  }, /*#__PURE__*/react.createElement(growth_form_controls_cityDropdown_dweb_esm_Dropdown, {
    onClick: function onClick() {
      return setShowOptions(!showOptions);
    },
    isActive: showOptions
  }, /*#__PURE__*/react.createElement(SelectLabel, {
    isSelected: !!selectedCity.name
  }, "City"), selectedCity.name && /*#__PURE__*/react.createElement(SelectedOption, null, selectedCity.name)), showOptions && /*#__PURE__*/react.createElement(OptionList, {
    style: listContainer
  }, /*#__PURE__*/react.createElement(SearchResultMenu, {
    selectedID: selectedCity.id,
    options: options,
    handleOptionSelected: citySelectHandler,
    handleSearch: function handleSearch(str) {
      return setSearchString(str);
    },
    selectedValue: selectedCity.name,
    inputPlaceholder: searchPlaceholder || 'Enter City name',
    error: error
  })));
}
CityDropdown.defaultProps = {
  options: [],
  defaultSelctedId: '',
  searchPlaceholder: '',
  customStyles: {}
};



// EXTERNAL MODULE: ../../node_modules/@growth/api-calls/dist/growth-api-calls.esm.js + 5 modules
var growth_api_calls_esm = __webpack_require__(92878);
// EXTERNAL MODULE: ../../node_modules/fecha/lib/fecha.js
var fecha = __webpack_require__(24051);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/date-utils/dist/growth-date-utils.esm.js


var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      f = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (f) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};

var formatDate = function formatDate(date, formatStr) {
  if (formatStr === void 0) {
    formatStr = "D MMM'YY dddd";
  }

  return format(date, formatStr);
};

var formatDateString = function formatDateString(date) {
  return date && formatDate(date).split(' ').slice(0, 2).join(' ');
};

var formatDayString = function formatDayString(date) {
  return date && formatDate(date).split(' ').slice(2).join('');
};

var addDays = function addDays(date, days) {
  var currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};

var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

var getTimeZone = function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};



// EXTERNAL MODULE: ../../node_modules/@growth/toast/dist/growth-toast.esm.js
var growth_toast_esm = __webpack_require__(94978);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js
























function growth_gi_dweb_auth_esm_extends() {
  growth_gi_dweb_auth_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return growth_gi_dweb_auth_esm_extends.apply(this, arguments);
}

var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;
  var adobeInstance = _ref.adobeInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: AnalyticsPluginAdobe({
      page: {
        pageInfo: growth_gi_dweb_auth_esm_extends({}, pageInfo, {
          lob: lobName
        })
      },
      account: {
        accountInfo: growth_gi_dweb_auth_esm_extends({}, accountInfo, {
          website: 'goibibo'
        })
      }
    }, debug || false),
    debug: debug || false
  });
};

var initAnalytics = function initAnalytics(_ref) {
  var lobName = _ref.lobName,
    debug = _ref.debug;
  var adobeInstance = new growth_web_analytics_esm/* default */.Z();
  initOmnitureAnalytics({
    adobeInstance: adobeInstance,
    lobName: lobName,
    debug: debug
  });
  return {
    adobeInstance: adobeInstance
  };
};

function growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$b;
var AuthContainer$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$b || (_templateObject$b = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));

var _templateObject$a, _templateObject2$7;
var AuthVerificationFlowSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$a || (_templateObject$a = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 405px;\n    height: ", ";\n    margin: ", ";\n\t\tpadding: ", ";\n    border-radius: 12px;\n    flex-shrink: 0;\n    box-shadow: -5px 0 9px 0 rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    position: relative;\n"])), function (props) {
  return props.isPostAuth ? "auto" : '456px';
}, function (props) {
  return props.isPostAuth ? "40px" : '0';
}, function (props) {
  return props != null && props.isPostAuth ? "20px" : '44px 50px 25px 50px';
});
var AuthVerificationFlowCloseIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2$7 || (_templateObject2$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n"])));

var _templateObject$9, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1;
var MobileContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$9 || (_templateObject$9 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n\tposition: relative;\n"])));
var MobileHeading = styled_components_browser_esm/* default.h3 */.ZP.h3(_templateObject2$6 || (_templateObject2$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1);
var MobileInputWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$5 || (_templateObject3$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 56px;\n\tborder-radius: 4px;\n\tborder: solid 1px #e4e4e4;\n\tposition: relative;\n\tdisplay: flex;\n\n\t", "\n\n\t.loginCont__input.loginCont__input.loginCont__input {\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tcolor: #717171;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tline-height: 17px;\n\t\tpadding: 0 17px;\n\t\tborder: 0;\n\t\tborder-radius: 4px;\n\n\t\t&:focus  {\n\t\t\toutline: 0;\n\t\t}\n\t}\n\n\t.loginCont__code {\n\t\tbackground: #fff;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.loginCont__label {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -9px;\n\t\tbackground-color: #fff;\n\t\tpadding: 0px 5px;\n\t\t", "\n\t\tline-height: 16px;\n\t\tcolor: #717171;\n\t\tfont-family: Rubik;\n\t}\n\n\t.show__label {\n\t\tdisplay: inline-flex;\n\n    &.focused {\n      color: #2276e3;\n    }\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #717171;\n\t\tline-height: 17px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n"])), function (props) {
  if (props.error) {
    return "\n          border-color: rgb(229, 52, 66);\n          .loginCont__label{\n            color: rgb(229, 52, 66) !important;\n          }\n          .loginCont__input.loginCont__input.loginCont__input.loginCont__input {\n            padding-right: 40px;\n          } \n      ";
  }
  if (props.valid) {
    return "\n          border-color: #00962d;\n          .loginCont__label{\n            color: #00962d !important;\n          }\n          .loginCont__input.loginCont__input.loginCont__input.loginCont__input {\n            padding-right: 40px;\n          } \n        ";
  }
  if (props.isFocused) {
    return "border-color: #2276e3;";
  }
  return null;
}, growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var LoginSubmitButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject4$5 || (_templateObject4$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", "\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var LoginTermsAndCondition = styled_components_browser_esm/* default.p */.ZP.p(_templateObject5$4 || (_templateObject5$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tposition: absolute;\n\tbottom: 0;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var InputMessageIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject6$3 || (_templateObject6$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: 16px;\n\ttop: 17px;\n\ttransform: scale(0.84);\n"])));
var MessageText = styled_components_browser_esm/* default.p */.ZP.p(_templateObject7$1 || (_templateObject7$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\n\t", "\n"])), function (props) {
  if (props.error) {
    return "color: rgb(229, 52, 66);\n\t\t\t margin-top: 10px;\n\t\t\t";
  }
  if (props.success) {
    return "\n            color: #00962d;\n            \n             margin-top: 10px;\n            ";
  }
  if (props.loading) {
    return "\n\t\t\t margin-top: 10px;\n\t\t\t ";
  }
  return '';
});
var InputDropDownWrap = styled_components_browser_esm/* default.span */.ZP.span(_templateObject8$1 || (_templateObject8$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n\twidth: 141px;\n\t.arrow-down {\n\t\tborder: solid #016eff;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 3px;\n\t\tfont-weight: 400;\n\t\ttransform: rotate(45deg);\n\t}\n\t.arrow-up {\n\t\tborder: solid #016eff;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 3px;\n\t\tfont-weight: 400;\n\t\ttransform: rotate(225deg);\n\t}\n\t.cntryFlgImg {\n\t\tmargin-left: 15px;\n\t}\n"])));
var CountryCode = styled_components_browser_esm/* default.span */.ZP.span(_templateObject9$1 || (_templateObject9$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: #777777;\n"])));
var ListHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10$1 || (_templateObject10$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tcolor: #b0b0b0;\n\tmargin: 10px 0;\n"])));
var growth_gi_dweb_auth_esm_List = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11$1 || (_templateObject11$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\tpadding: 10px 0;\n\tcolor: #777777;\n\n\tp {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t.nameFlag {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\t.nameFlag .cntryName {\n\t\tmargin-left: 15px;\n\t}\n\n\t.nameFlag .cntryFlgImg {\n\t\tmargin-left: 0px;\n\t}\n\n\t.cntryCode {\n\t\tmargin-left: auto;\n\t\tfont-weight: 500;\n\t}\n"])));
var ConfirmationContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12$1 || (_templateObject12$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 16px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: start;\n\tcursor: pointer;\n\n\tinput {\n\t\tmargin: 3px;\n\t\tcursor: pointer;\n\t\theight: 18px;\n    width: 39px;\n    display: flex;\n\n\t\t&[type=\"checkbox\"]:checked {\n\t\t\tbackground-color: #2276e3;\n\t\t}\n\t}\n\n\tlabale {\n\t\tcursor: pointer;\n\t}\n"])));
var StyledLabel = styled_components_browser_esm/* default.label */.ZP.label(_templateObject13$1 || (_templateObject13$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: #717171;\n\tfont-family: Rubik;\n  font-size: 12px;\n\tmargin-left: 6px;\n"])));

var LOGIN_WITH_MOBILE = {
  heading: 'Login/Signup',
  subHeading: '',
  submitButton: 'Continue',
  label: 'Enter your Mobile Number',
  internationalCheckBoxMsg: "By proceeding, you agree to receive OTP via SMS/WhatsApp from Goibibo and agree to Goibibo's <a href=\"https://www.goibibo.com/info/privacy/\" target=\"_blank\">Privacy Policy</a>, <a href=\"https://www.goibibo.com/info/user-agreement/\" target=\"_blank\">User Agreement</a> and <a href=\"https://www.goibibo.com/info/terms-of-services/\" target=\"_blank\">Terms of Service</a>.",
  termsPolicy: 'By proceeding, you agree to GoIbibo’s <a href="https://www.goibibo.com/info/privacy/" target="_blank">Privacy Policy</a>, <a href="https://www.goibibo.com/info/user-agreement/" target="_blank">User Agreement</a> and <a href="https://www.goibibo.com/info/terms-of-services/" target="_blank">Terms of Service</a>'
};

var InputWrapper = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _ref$inputName = _ref.inputName,
    inputName = _ref$inputName === void 0 ? 'text' : _ref$inputName,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    maxlength = _ref.maxlength,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    inputPrefix = _ref.inputPrefix,
    onChange = _ref.onChange,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    inputClassName = _ref.inputClassName,
    placeholder = _ref.placeholder,
    inputVal = _ref.inputVal,
    _ref$inputDisabled = _ref.inputDisabled,
    inputDisabled = _ref$inputDisabled === void 0 ? false : _ref$inputDisabled,
    children = _ref.children;
    _ref.onInputClick;
    var forceShowLabel = _ref.forceShowLabel;
  var _useState = (0,react.useState)(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) onChange(e);
  };
  var getLabelClass = function getLabelClass() {
    var className = 'loginCont__label';
    if (isFocused || forceShowLabel) {
      className += ' show__label focused';
    } else if (inputVal) {
      className += ' show__label';
    }
    return className;
  };
  var handleFocus = function handleFocus() {
    if (!inputDisabled) {
      setIsFocused(true);
    }
  };
  var handleBlur = function handleBlur() {
    setIsFocused(false);
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(MobileInputWrapper, {
    error: isError,
    valid: isValid,
    isFocused: isFocused || forceShowLabel
  }, /*#__PURE__*/react.createElement("span", {
    className: getLabelClass()
  }, label), inputPrefix ? children : null, /*#__PURE__*/react.createElement("input", {
    ref: ref,
    className: inputClassName,
    onChange: onChangeHandler,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    autoFocus: autoFocus,
    placeholder: !isFocused && placeholder,
    value: inputVal,
    disabled: inputDisabled,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), (isError || isValid) && /*#__PURE__*/react.createElement(InputMessageIcon, {
    className: "logSprite " + (isError ? 'icInfoPink' : 'icSuccessSmall')
  })));
});
InputWrapper.displayName = 'InputWrapper';

/** Create a new configStore instance for dweb-auth */
var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();
(0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var OTP_RESEND_TIME = 30;
var CONFIG_KEY_DWEB_AUTH = 'growth-dweb-header-config';
var CONFIG_KEY_COUNTRY_LIST = 'growth_country_list_config';
var IND_COUNTRY_CODE = {
  name: 'India',
  id: 'in',
  code: 91,
  captcha: false
};
var GENDER_LIST = [{
  label: 'Male',
  id: 'MALE'
}, {
  label: 'Female',
  id: 'FEMALE'
}, {
  label: 'Others',
  id: 'OTHER'
}];

var DropDownOption = function DropDownOption(_ref) {
  var id = _ref.id,
    code = _ref.code,
    name = _ref.name,
    handleKeyDownDropDown = _ref.handleKeyDownDropDown,
    onClick = _ref.onClick;
  return /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm_List, {
    key: code,
    role: "button",
    onClick: onClick,
    onKeyDown: handleKeyDownDropDown,
    tabIndex: 0 // Make the div focusable to receive keyboard events
  }, /*#__PURE__*/react.createElement("p", null, /*#__PURE__*/react.createElement("div", {
    className: "nameFlag"
  }, /*#__PURE__*/react.createElement(CountryImg, {
    countryCode: id
  }), /*#__PURE__*/react.createElement("span", {
    className: "cntryName"
  }, " ", " " + name)), /*#__PURE__*/react.createElement("span", {
    className: "cntyCode"
  }, "+" + code)));
};

var CountryCodeDropDownOptions = function CountryCodeDropDownOptions(_ref) {
  var handleDropDownSelect = _ref.handleDropDownSelect,
    _handleKeyDownDropDown = _ref.handleKeyDownDropDown;
  var _useConfigStore = useConfigStore(function (s) {
      return {
        countryListLoading: s.loading,
        countryList: s.data
      };
    }),
    countryList = _useConfigStore.countryList,
    countryListLoading = _useConfigStore.countryListLoading;
  var _useState = (0,react.useState)([]),
    visibleDropDown = _useState[0],
    setVisibleDropDown = _useState[1];
  (0,react.useEffect)(function () {
    var _countryList$COMMON;
    var data = (countryList == null || (_countryList$COMMON = countryList.COMMON) == null ? void 0 : _countryList$COMMON[CONFIG_KEY_COUNTRY_LIST]) || [];
    if (data.length) setVisibleDropDown(data);
  }, [countryList]);
  var handleDropDownSearch = function handleDropDownSearch(value) {
    var _countryList$COMMON2;
    var data = (countryList == null || (_countryList$COMMON2 = countryList.COMMON) == null ? void 0 : _countryList$COMMON2[CONFIG_KEY_COUNTRY_LIST]) || [];
    if (value) {
      var filteredLists = data.map(function (category) {
        var filteredList = category.list.filter(function (country) {
          return country.name.toLowerCase().includes(value.toLowerCase()) || (country == null ? void 0 : country.code.toString().includes(value.toLowerCase()));
        });
        return {
          name: category.name,
          list: filteredList
        };
      });
      var updatedList = filteredLists.filter(function (category) {
        return category.list.length > 0;
      });
      setVisibleDropDown(updatedList);
    } else {
      setVisibleDropDown(data);
    }
  };
  var DropDownOptions = countryListLoading ? [/*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, {
    key: "circular_loader",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '150px'
    }
  })] : visibleDropDown.map(function (item) {
    var _item$list;
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ListHeading, null, item == null ? void 0 : item.name), item == null || (_item$list = item.list) == null ? void 0 : _item$list.map(function (listItem) {
      return /*#__PURE__*/react.createElement(DropDownOption, growth_gi_dweb_auth_esm_extends({
        key: listItem == null ? void 0 : listItem.id
      }, listItem, {
        handleKeyDownDropDown: function handleKeyDownDropDown() {
          return _handleKeyDownDropDown(listItem);
        },
        onClick: function onClick() {
          return handleDropDownSelect(listItem);
        }
      }));
    }));
  });
  return /*#__PURE__*/react.createElement(Dropdown, {
    listTitle: "",
    showSearchField: true,
    handleInputSearch: handleDropDownSearch,
    options: DropDownOptions,
    searchFieldPlaceholder: "Country Name or Code"
  });
};

var InputPrefix = function InputPrefix(_ref) {
  var setShowCountryDropDown = _ref.setShowCountryDropDown,
    id = _ref.id,
    code = _ref.code,
    showDropDownIcon = _ref.showDropDownIcon;
  var _useState = (0,react.useState)(false),
    isDropDownOpen = _useState[0],
    setDropDownVisibility = _useState[1];
  var onDropDownClick = function onDropDownClick() {
    setDropDownVisibility(function (val) {
      return !val;
    });
    setShowCountryDropDown(function (val) {
      return !val;
    });
  };
  return /*#__PURE__*/react.createElement(InputDropDownWrap, {
    onClick: onDropDownClick
  }, /*#__PURE__*/react.createElement(CountryImg, {
    countryCode: id
  }), /*#__PURE__*/react.createElement(CountryCode, null, "+ ", code), showDropDownIcon && /*#__PURE__*/react.createElement("span", {
    className: isDropDownOpen ? "arrow-up" : "arrow-down"
  }));
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var _templateObject$8;
var CaptchaWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$8 || (_templateObject$8 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 15px;\n"])));

var ReactGoogleCaptcha = /*#__PURE__*/react.lazy(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.bind(__webpack_require__, 3176));
});
/**
 * GoogleCaptcha component
 * @param onRecaptchaSubmit
 */

var GoogleCaptcha = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var onRecaptchaSubmit = _ref.onRecaptchaSubmit;
  /**
      * Handle recaptcha
      * @param it
      */
  var handleRecaptcha = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(token) {
      var _ref$current, response, _ref$current2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0,growth_auth_helpers_esm/* fetchRecaptchaVerification */.Xb)({
              platform: 'dweb',
              recaptchaToken: token,
              deviceId: visitorIdBrowser()
            });
          case 3:
            response = _context.sent;
            if (response != null && response.recaptchaAuth) onRecaptchaSubmit(false);else ref == null || (_ref$current = ref.current) == null || _ref$current.reset();
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            ref == null || (_ref$current2 = ref.current) == null || _ref$current2.reset();
            if (token) onRecaptchaSubmit(true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function handleRecaptcha(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/react.createElement(CaptchaWrapper, null, /*#__PURE__*/react.createElement(react.Suspense, {
    fallback: /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    })
  }, /*#__PURE__*/react.createElement(ReactGoogleCaptcha, {
    ref: ref,
    sitekey: growth_auth_helpers_esm/* GOOGLE_RECAPTCHA_V2_CHECKBOX_SITE_KEY */.ZW,
    onChange: handleRecaptcha,
    type: "image"
  })));
});
GoogleCaptcha.displayName = "GoogleCaptcha";

var MobileForm = function MobileForm(_ref) {
  var _data$validation, _data$validation2, _data$validation3, _data$validation4, _data$validation5, _data$validation6;
  var onFormSubmit = _ref.onFormSubmit,
    prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen,
    prefillCountryCode = _ref.prefillCountryCode,
    allowInternationalLogin = _ref.allowInternationalLogin;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state;
    }),
    fetch = _useSendOtpStore.fetch,
    data = _useSendOtpStore.data,
    checkValid = _useSendOtpStore.checkValid,
    loading = _useSendOtpStore.loading,
    error = _useSendOtpStore.error;
  var _useConfigStore = useConfigStore(function (s) {
      return {
        configStoreLoaded: s.loaded,
        configStoreError: s.error,
        configStoreData: s.data
      };
    }),
    configStoreData = _useConfigStore.configStoreData,
    configStoreError = _useConfigStore.configStoreError,
    configStoreLoaded = _useConfigStore.configStoreLoaded;
  var _useState = (0,react.useState)(false),
    showCountryDropDown = _useState[0],
    setShowCountryDropDown = _useState[1];
  var _useState2 = (0,react.useState)(IND_COUNTRY_CODE),
    countryCode = _useState2[0],
    setCountryCode = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    showInternationalNumberConfirmation = _useState3[0],
    setShowInternationalNumberConfirmation = _useState3[1];
  var _useState4 = (0,react.useState)(false),
    isChecked = _useState4[0],
    setIsChecked = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    isNumberValid = _useState5[0],
    setIsNumberValid = _useState5[1];
  var _useState6 = (0,react.useState)(false),
    captchaPassed = _useState6[0],
    setCaptchaPassed = _useState6[1];
  var recaptchaRef = (0,react.useRef)();
  var inputRef = (0,react.useRef)(null);
  var isNonIndianCountryCode = (countryCode == null ? void 0 : countryCode.code) !== IND_COUNTRY_CODE.code;
  var enableInternationalNumber = function enableInternationalNumber() {
    if (allowInternationalLogin && configStoreLoaded && !configStoreError) {
      var _configStoreData$COMM;
      var d = configStoreData == null || (_configStoreData$COMM = configStoreData.COMMON) == null || (_configStoreData$COMM = _configStoreData$COMM[CONFIG_KEY_DWEB_AUTH]) == null ? void 0 : _configStoreData$COMM.data;
      if (d) {
        return d.enableInternationalNumber;
      }
    }
    return false;
  };
  var getCountryCode = function getCountryCode() {
    if (configStoreLoaded && !configStoreError) {
      var _configStoreData$COMM2;
      var d = configStoreData == null || (_configStoreData$COMM2 = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM2[CONFIG_KEY_COUNTRY_LIST];
      if (d) {
        return d;
      }
    }
    return [];
  };
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data,
        prefillfetch: s.fetch,
        prefillDetailsloaded: s.loaded,
        prefillLoading: s.loading,
        prefillError: s.error,
        controller: s.controller,
        setUserInputMobileNumber: s.setUserInputMobileNumber,
        userInputMobileNumber: s.userInputMobileNumber
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData,
    prefillfetch = _usePrefillLoginDetai.prefillfetch,
    prefillDetailsloaded = _usePrefillLoginDetai.prefillDetailsloaded,
    prefillError = _usePrefillLoginDetai.prefillError,
    controller = _usePrefillLoginDetai.controller,
    prefillLoading = _usePrefillLoginDetai.prefillLoading,
    setUserInputMobileNumber = _usePrefillLoginDetai.setUserInputMobileNumber,
    userInputMobileNumber = _usePrefillLoginDetai.userInputMobileNumber;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var onOtpSendSuccess = function onOtpSendSuccess() {
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Success',
        type: "itemSuccess",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (onFormSubmit) onFormSubmit();
  };
  var isValidMobileNumber = function isValidMobileNumber() {
    var _inputRef$current;
    var mobileNumber = ((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value) || '';
    var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
    var isValid = checkValid(mobileNumber, isMobileNumberEncoded, isNonIndianCountryCode);
    setIsNumberValid(isValid);
  };
  var handleFormSubmit = function handleFormSubmit(e) {
    if (e) e.preventDefault();
    (0,growth_pdt_push_esm/* pdtPush */.g)('login_module_get_otp', {
      event_detail: {
        event_type: 'click_event|onboarding_click',
        event_value: 'onboarding_flow'
      }
    });
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Clicked',
        type: "cardClick",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (!loading) {
      var _inputRef$current2;
      var mobileNumber = ((_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value) || '';
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      var isValid = (countryCode == null ? void 0 : countryCode.captcha) || checkValid(mobileNumber, isMobileNumberEncoded, isNonIndianCountryCode);
      if (isValid) {
        setUserInputMobileNumber({
          mobile: mobileNumber,
          countryCode: countryCode
        });
        fetch({
          platform: 'dweb',
          data: {
            mobileNumber: mobileNumber,
            countryCode: countryCode == null ? void 0 : countryCode.code,
            loginType: 'mobile',
            encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
            isEncoded: isMobileNumberEncoded || undefined
          },
          onSuccess: onOtpSendSuccess
        });
      }
    }
  };
  (0,react.useEffect)(function () {
    if (!prefillMobileNumber && !userInputMobileNumber) {
      prefillfetch({
        platform: 'dweb'
      });
    }
  }, [prefillMobileNumber, userInputMobileNumber]);

  // Function to get the prefilled mobile number from the API if available
  var getPrefillMobileNumberViaApi = (0,react.useCallback)(function () {
    return prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.encodedMobileNumber : null;
  }, [prefillData, prefillDetailsloaded, prefillError]);
  // Function to get the prefilled country code from the API if available
  var getPrefillCountryCodeViaApi = (0,react.useCallback)(function () {
    return prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.countryCode : null;
  }, [prefillData, prefillDetailsloaded, prefillError]);
  // Function to get the mobile number, prioritizing prefilled and user input values
  var getMobileNumber = (0,react.useCallback)(function () {
    var _ref2;
    return (_ref2 = prefillMobileNumber != null ? prefillMobileNumber : userInputMobileNumber == null ? void 0 : userInputMobileNumber.mobile) != null ? _ref2 : getPrefillMobileNumberViaApi();
  }, [prefillMobileNumber, userInputMobileNumber]);
  // Function to get the country code data, prioritizing prefilled and user input values
  var getCountryCodeData = (0,react.useCallback)(function () {
    var _ref3, _ref4;
    return (_ref3 = (_ref4 = prefillCountryCode != null ? prefillCountryCode : userInputMobileNumber == null ? void 0 : userInputMobileNumber.countryCode) != null ? _ref4 : getCountryCode().map(function (c) {
      var _c$list;
      return c == null || (_c$list = c.list) == null ? void 0 : _c$list.find(function (code) {
        return code === getPrefillCountryCodeViaApi();
      });
    })[0]) != null ? _ref3 : IND_COUNTRY_CODE;
  }, [prefillCountryCode, userInputMobileNumber]);
  (0,react.useEffect)(function () {
    var mobile = getMobileNumber();
    var country = getCountryCodeData();
    if (inputRef.current) {
      if (mobile) {
        inputRef.current.value = mobile;
        if (country) setCountryCode(country);
        isValidMobileNumber();
      }

      // Only for Indian No. we will be automatically triggering otp send for prefilled mobile number
      if (!isNonIndianCountryCode && prefillMobileNumber && skipMobileScreen) {
        handleFormSubmit();
      }
    }
  }, [prefillMobileNumber, skipMobileScreen, getMobileNumber, getCountryCodeData]);
  (0,react.useEffect)(function () {
    if (isNonIndianCountryCode) {
      setShowInternationalNumberConfirmation(true);
    } else {
      setShowInternationalNumberConfirmation(false);
    }
  }, [countryCode]);

  /**
   *
   * @param e synthetic event
   * auto submit when user enters 10 digit
   */
  var handleInputChange = function handleInputChange(e) {
    var _inputRef$current3, _inputRef$current4;
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    // This checking of length is required to prevent error UI in case user is in process of typing
    if ((countryCode == null ? void 0 : countryCode.code) === IND_COUNTRY_CODE.code && ((_inputRef$current3 = inputRef.current) == null || (_inputRef$current3 = _inputRef$current3.value) == null ? void 0 : _inputRef$current3.length) !== growth_auth_helpers_esm/* MOBILE_NUMBER_MAX_LENGTH */.Zb) {
      setIsNumberValid(false);
      return;
    }
    if (isNonIndianCountryCode && ((_inputRef$current4 = inputRef.current) == null || (_inputRef$current4 = _inputRef$current4.value) == null ? void 0 : _inputRef$current4.length) < growth_auth_helpers_esm/* INTL_MOBILE_NUMBER_MIN_LENGTH */.O$) {
      setIsNumberValid(false);
      return;
    }
    isValidMobileNumber();
    // Only For Indian No. Automatically Send OTP
    if (!isNonIndianCountryCode) {
      handleFormSubmit(e);
    }
  };
  var subText = function subText(_ref5) {
    var waiting = _ref5.loading,
      failure = _ref5.error,
      validationMessage = _ref5.validationMessage;
    if (waiting) {
      return 'Sending OTP...';
    }
    if (!waiting && failure) {
      var _data$error;
      return (_data$error = data.error) == null ? void 0 : _data$error.errorMsg;
    }
    if (validationMessage) {
      return validationMessage;
    }
    return '';
  };
  var handleInputClick = function handleInputClick() {
    var _inputRef$current5;
    (0,growth_pdt_push_esm/* pdtPush */.g)('login_module_entry_mobile', {
      event_detail: {
        event_type: 'click_event|onboarding_click',
        event_value: 'onboarding_flow|mobileInput'
      }
    });
    if (prefillLoading) {
      controller == null || controller.abort();
    }
    if ((0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(inputRef == null || (_inputRef$current5 = inputRef.current) == null ? void 0 : _inputRef$current5.value, prefillData == null ? void 0 : prefillData.encodedMobileNumber)) {
      if (inputRef.current) inputRef.current.value = '';
      isValidMobileNumber();
    }
  };
  var handleCountryCode = function handleCountryCode(code) {
    setShowCountryDropDown(false);
    setCountryCode(code);
    if (code.captcha) {
      var _recaptchaRef$current;
      setCaptchaPassed(false);
      recaptchaRef == null || (_recaptchaRef$current = recaptchaRef.current) == null || _recaptchaRef$current.reset();
    }
  };
  var handleKeyDown = function handleKeyDown(event, code) {
    if (event.key === 'Enter' || event.key === ' ') {
      handleCountryCode(code);
    }
  };
  var getSubmitBtnClass = function getSubmitBtnClass() {
    var isDisabled = false;
    if (!isNumberValid) {
      isDisabled = true;
    }
    if (countryCode != null && countryCode.captcha && !captchaPassed) {
      isDisabled = true;
    }
    if (showInternationalNumberConfirmation && !isChecked) {
      isDisabled = true;
    }
    return isDisabled ? 'disabled' : '';
  };
  var termsAndConditionClick = function termsAndConditionClick() {
    adobe.track('ctaClick', {
      cta: {
        name: "Login_TNC",
        type: "itemClick",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  var showInternationalNumber = enableInternationalNumber();
  return /*#__PURE__*/react.createElement("form", {
    onSubmit: handleFormSubmit,
    autoComplete: "on"
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    label: LOGIN_WITH_MOBILE.label,
    maxlength: "" + countryCode.code === "" + IND_COUNTRY_CODE.code ? growth_auth_helpers_esm/* MOBILE_NUMBER_MAX_LENGTH */.Zb : null,
    inputPrefix: true,
    onInputClick: handleInputClick,
    onChange: handleInputChange,
    isError: error || ((_data$validation = data.validation) == null ? void 0 : _data$validation.message),
    isValid: (_data$validation2 = data.validation) == null ? void 0 : _data$validation2.isValidMobile,
    ref: inputRef,
    inputName: "phone",
    inputType: "text",
    inputClassName: "loginCont__input",
    inputDisabled: loading || !((_data$validation3 = data.validation) != null && _data$validation3.message) && isMobileNumberDisabled,
    forceShowLabel: true
  }, /*#__PURE__*/react.createElement(InputPrefix, {
    id: countryCode.id,
    code: "" + countryCode.code,
    setShowCountryDropDown: setShowCountryDropDown,
    showDropDownIcon: showInternationalNumber
  })), showInternationalNumber && showCountryDropDown ? /*#__PURE__*/react.createElement(CountryCodeDropDownOptions, {
    handleDropDownSelect: handleCountryCode,
    handleKeyDownDropDown: handleKeyDown
  }) : null, countryCode != null && countryCode.captcha ? /*#__PURE__*/react.createElement(GoogleCaptcha, {
    onRecaptchaSubmit: function onRecaptchaSubmit(val) {
      return setCaptchaPassed(!val);
    },
    ref: recaptchaRef
  }) : null, /*#__PURE__*/react.createElement(MessageText, {
    success: ((_data$validation4 = data.validation) == null ? void 0 : _data$validation4.isValidMobile) && !loading,
    error: !loading && error || ((_data$validation5 = data.validation) == null ? void 0 : _data$validation5.message),
    loading: loading
  }, subText({
    loading: loading,
    error: error,
    validationMessage: (_data$validation6 = data.validation) == null ? void 0 : _data$validation6.message
  })), /*#__PURE__*/react.createElement(LoginSubmitButton, {
    className: getSubmitBtnClass(),
    type: "submit"
  }, LOGIN_WITH_MOBILE.submitButton), showInternationalNumberConfirmation ? /*#__PURE__*/react.createElement(ConfirmationContainer, null, /*#__PURE__*/react.createElement("input", {
    id: "international-confirmation",
    type: "checkbox",
    checked: isChecked,
    onChange: function onChange() {
      return setIsChecked(!isChecked);
    }
  }), /*#__PURE__*/react.createElement(StyledLabel, {
    htmlFor: "international-confirmation",
    dangerouslySetInnerHTML: {
      __html: LOGIN_WITH_MOBILE.internationalCheckBoxMsg
    }
  })) : /*#__PURE__*/react.createElement(LoginTermsAndCondition, {
    onClick: termsAndConditionClick,
    "data-id": "terms-condition",
    dangerouslySetInnerHTML: {
      __html: LOGIN_WITH_MOBILE.termsPolicy
    }
  }));
};

var AUTH_FLOW_STEPS = {
  STEP_MOBILE: 'mobile',
  STEP_OTP: 'otp',
  STEP_PASSWORD: 'pwd',
  STEP_POST_AUTH: 'postlogin',
  LOADER: 'loader'
};

var useAuthFlow = (0,esm/* create */.Ue)(function (set) {
  return {
    activeAuthFlow: AUTH_FLOW_STEPS.STEP_MOBILE,
    setActiveAuthFlow: function setActiveAuthFlow(type) {
      return set({
        activeAuthFlow: type
      });
    }
  };
});

var LoginWithMobile = function LoginWithMobile(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen,
    prefillCountryCode = _ref.prefillCountryCode,
    allowInternationalLogin = _ref.allowInternationalLogin;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)();
    _useAnalytics.adobe;
  var setActiveAuthFlow = useAuthFlow(function (state) {
    return state.setActiveAuthFlow;
  });
  var onFormSubmit = function onFormSubmit() {
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_OTP);
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, LOGIN_WITH_MOBILE.heading), /*#__PURE__*/react.createElement(MobileForm, {
    prefillMobileNumber: prefillMobileNumber,
    onFormSubmit: onFormSubmit,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen,
    prefillCountryCode: prefillCountryCode,
    allowInternationalLogin: allowInternationalLogin
  })));
};

var Heading = 'Verify OTP';
var SubHeading$1 = 'Enter 4 digit OTP sent to';
var RESEND_OTP = {
  label: "Didn't get the OTP?",
  timerHeading: 'Resend OTP in'
};
var OTP_TYPE = {
  sms: 'mobile',
  whatsApp: 'whatsapp'
};
var VERIFY_OTP_MSG = {
  verified: 'OTP verified',
  verifying: 'Verifying OTP...',
  invalidOtp: 'Please enter a valid OTP'
};
var TERMS_CONDITION = {
  whatsApp: 'I agree to receive critical messages such as OTP, booking details on WhatsApp.',
  sms: 'I agree to receive critical messages such as OTP, booking details on SMS.'
};

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2;
var SubHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$7 || (_templateObject$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 30px;\n\tmargin-top: -22px;\n\t", "\n\tspan {\n\t\t", "\n\t}\n\t.icEdit {\n\t\tmargin-left: 3px;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW1 */.iH.BaseW1, growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var OtpWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$5 || (_templateObject2$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t.verifyOtpCont__otpFiled {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid rgb(1, 110, 255);\n\t\tcolor: rgb(79, 82, 90);\n\t\toutline: 0px;\n\t\twidth: 60px !important;\n\t\ttext-align: center;\n\t\tpadding: 0;\n\t\t", "\n\t}\n\t&.otpError .verifyOtpCont__otpFiled {\n\t\tborder-color: rgb(229, 52, 66);\n\t}\n\t.verifyOtpCont__message {\n\t\tmin-height: 50px;\n\t}\n\t.verifyOtpCont__otpCont {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OtpErrorContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$4 || (_templateObject3$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 8px;\n\t.errorIcon {\n\t\tmargin-right: 10px;\n\t}\n\t.errorMessage {\n\t\tcolor: rgb(229, 52, 66);\n\t\t", "\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimerContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$4 || (_templateObject4$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 10px;\n\t.gi-resend-timer {\n\t\tmargin-left: 5px;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimer = styled_components_browser_esm/* default.span */.ZP.span(_templateObject5$3 || (_templateObject5$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var ResendSmsTypeContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$2 || (_templateObject6$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t&.disableInfo {\n\t\topacity: 0.3;\n\t\tpointer-events: none;\n\t}\n\t.otpScreen__social {\n\t\tdisplay: flex;\n\t}\n\t.otpScreen__social > li {\n\t\twidth: 94px;\n\t\tmargin: 0 0 0 10px;\n\t\tpadding: 4px 14px 5px 8px;\n\t\tborder-radius: 2px;\n\t\tborder: solid 1px #cecece;\n\t\tbackground-color: #fff;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t}\n\t.otpScreen__social > li .gi-tooltip {\n\t\tdisplay: none;\n\t}\n\t.otpScreen__social > li:hover .gi-tooltip {\n\t\tdisplay: block;\n\t}\n"])));

var OtpInputWrapper = function OtpInputWrapper(_ref) {
  var mobileNumber = _ref.mobileNumber,
    countryCode = _ref.countryCode,
    onOtpSuccess = _ref.onOtpSuccess,
    isExistingUser = _ref.isExistingUser;
  var verifyNewUser = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (state) {
    return state.fetch;
  });
  var fetchLoginDetails = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (state) {
    return state.fetch;
  });
  var otpData = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  });
  var _useState = (0,react.useState)(''),
    otp = _useState[0],
    setOtp = _useState[1];
  var _useState2 = (0,react.useState)(false),
    otpVerifying = _useState2[0],
    setOtpVerifying = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    otpError = _useState3[0],
    setOtpError = _useState3[1];
  var _useState4 = (0,react.useState)(''),
    otpErrorMsg = _useState4[0],
    setOtpErrorMsg = _useState4[1];
  (0,react.useEffect)(function () {
    /**
     * this check if otp is invalid then bring focus to 4th input field
     */
    if (otpError && !otpVerifying) {
      var otpList = document.querySelectorAll('input.verifyOtpCont__otpFiled') || [];
      if (otpList[3]) {
        otpList[3].focus();
      }
    }
  }, [otpError, otpVerifying]);
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var onOtpVerificationSuccess = function onOtpVerificationSuccess(details) {
    setOtpVerifying(false);
    if (onOtpSuccess) onOtpSuccess(details);
  };
  var onOtpVerificationError = function onOtpVerificationError(_ref2) {
    var code = _ref2.code;
    setOtpVerifying(false);
    if (code && code === growth_auth_helpers_esm/* INVALID_OTP_CODE */.Wp) {
      setOtpError(true);
      setOtpErrorMsg('Please enter a valid OTP');
    } else {
      setOtpError(true);
      setOtpErrorMsg('Some error occurred, please try again.');
    }
  };
  var resetErrorState = function resetErrorState() {
    setOtpError(false);
    setOtpErrorMsg('');
  };
  var submitOtp = function submitOtp(value) {
    setOtpVerifying(true);
    resetErrorState();
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_verify_otp_auto", {
      event_detail: {
        event_type: "click_event",
        event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
      }
    });
    if (isExistingUser) {
      fetchLoginDetails({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          countryCode: "" + countryCode,
          passwordType: 'OTP',
          password: value,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: otpData.isMobileNumberEncoded || undefined
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    } else {
      verifyNewUser({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          countryCode: "" + countryCode,
          passwordType: 'OTP',
          password: value
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    }
  };
  var handleOtpChange = function handleOtpChange(value) {
    setOtpVerifying(false);
    setOtp(value);
    if (value.length === 4) {
      submitOtp(value);
    }
  };
  return /*#__PURE__*/react.createElement(OtpWrapper, {
    className: otpError ? 'otpError' : ''
  }, /*#__PURE__*/react.createElement(lib/* default */.Z, {
    value: otp,
    onChange: handleOtpChange,
    numInputs: 4,
    separator: /*#__PURE__*/react.createElement("span", null, "\xA0"),
    containerStyle: "verifyOtpCont__otpCont",
    inputStyle: otpVerifying ? 'verifyOtpCont__otpFiled disabled' : 'verifyOtpCont__otpFiled',
    isInputNum: true,
    shouldAutoFocus: true,
    isDisabled: otpVerifying
  }), /*#__PURE__*/react.createElement("div", {
    className: "verifyOtpCont__message"
  }, otpVerifying && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, null), /*#__PURE__*/react.createElement("p", {
    className: "gr-append-left10 robotoRegular gr-font12"
  }, VERIFY_OTP_MSG.verifying)), otpError && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icInfoPink errorIcon"
  }), /*#__PURE__*/react.createElement("p", {
    className: "errorMessage"
  }, otpErrorMsg))));
};

var tooltipStyle = {
  width: '250px',
  top: 32
};
var tooltipStyle2 = {
  width: '250px',
  top: 32,
  right: 14
};
var ResendOtp = function ResendOtp(_ref) {
  var isExistingUser = _ref.isExistingUser;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return {
        resendOtpApi: state.fetch,
        apiLoading: state.loading,
        mobileNumber: state.data.mobileNumber,
        countryCode: state.data.countryCode
      };
    }, shallow/* shallow */.X),
    resendOtpApi = _useSendOtpStore.resendOtpApi,
    mobileNumber = _useSendOtpStore.mobileNumber,
    countryCode = _useSendOtpStore.countryCode,
    apiLoading = _useSendOtpStore.apiLoading;
  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow/* shallow */.X),
    prefillData = _usePrefillLoginDetai.prefillData;
  var _useState = (0,react.useState)(OTP_RESEND_TIME),
    resendTimer = _useState[0],
    setResendTimer = _useState[1];
  var _useState2 = (0,react.useState)(true),
    isTimerActive = _useState2[0],
    setIsTimerActive = _useState2[1];
  var resendSmsCountRef = (0,react.useRef)(0);
  (0,react.useEffect)(function () {
    var timerInterval;
    if (isTimerActive) {
      if (resendTimer === 0) {
        clearInterval(timerInterval);
        setIsTimerActive(false);
      }
      timerInterval = setInterval(function () {
        setResendTimer(function (timer) {
          return timer - 1;
        });
      }, 1000);
    }
    return function () {
      clearInterval(timerInterval);
    };
  }, [isTimerActive, resendTimer]);
  var resendOtp = function resendOtp(type) {
    if (!apiLoading) {
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_resend_otp|" + type, {
        event_detail: {
          event_type: "click_event|onboarding_click",
          event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "resend_otp",
          type: "cardClick|method:" + type + "|flow:" + (isExistingUser ? 'login' : 'signup'),
          componentName: 'GI_USER_ONBOARDING'
        }
      });
      setResendTimer(OTP_RESEND_TIME);
      setIsTimerActive(true);
      resendSmsCountRef.current += 1;
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      resendOtpApi({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          countryCode: countryCode,
          loginType: type,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined
        }
      });
    }
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ResendOtpTimerContainer, null, RESEND_OTP.label, ' ', resendTimer ? /*#__PURE__*/react.createElement("span", null, RESEND_OTP.timerHeading, /*#__PURE__*/react.createElement(ResendOtpTimer, {
    className: "gi-resend-timer"
  }, resendTimer < 10 ? "00:0" + resendTimer : "00:" + resendTimer)) : null), /*#__PURE__*/react.createElement(ResendSmsTypeContainer, {
    className: " " + (resendTimer || countryCode !== IND_COUNTRY_CODE.code && resendSmsCountRef.current === 1 ? 'disableInfo' : '')
  }, /*#__PURE__*/react.createElement(ResendOtpTimer, null, "Resend via :"), /*#__PURE__*/react.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.whatsApp);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icWhatsapp gr-append-right5"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle,
    notchPosition: "middle"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please ensure that you have entered your WhatsApp number for OTP"))), /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.sms);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSms gr-appendRight10"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "SMS"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle2,
    notchPosition: "right"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please don\u2019t share your OTP with anyone"))))));
};

var LoginWithOtp = function LoginWithOtp(_ref) {
  var isMobileNumberDisabled = _ref.isMobileNumberDisabled;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    countryCode = _useSendOtpStore.countryCode,
    data = _useSendOtpStore.data;
  var _useAuthFlow = useAuthFlow(function (state) {
      return state;
    }),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'OTP_Screen_Loaded',
        type: "itemLoaded|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)("login_module_otp", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_value: "onboarding_flow|" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
      }
    });
  }, []);
  var onEditMobile = function onEditMobile() {
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    adobe.track('ctaClick', {
      cta: {
        name: "Edit_Phone_Number",
        destination: 'Login_Popup_Load',
        type: "itemClick|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  var onOtpSuccess = function onOtpSuccess() {
    adobe.track('User_Login', {
      account: {
        accountInfo: {
          flow: "" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
        }
      },
      cta: {
        type: 'manual',
        name: "Onboarding_" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'Login' : 'Signup') + "_Success",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
  };
  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, Heading), /*#__PURE__*/react.createElement(SubHeading, null, SubHeading$1, /*#__PURE__*/react.createElement("span", null, " +", countryCode, "-", mobileNumber), !isMobileNumberDisabled && /*#__PURE__*/react.createElement("span", {
    className: "logSprite icEdit",
    onClick: onEditMobile,
    role: "presentation"
  })), /*#__PURE__*/react.createElement(OtpInputWrapper, {
    countryCode: countryCode,
    mobileNumber: mobileNumber,
    onOtpSuccess: onOtpSuccess,
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  }), /*#__PURE__*/react.createElement(ResendOtp, {
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, null, countryCode !== IND_COUNTRY_CODE.code ? TERMS_CONDITION.sms : TERMS_CONDITION.whatsApp));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$1, growth_gi_dweb_auth_esm_templateObject7, growth_gi_dweb_auth_esm_templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var CloseIconContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$6 || (_templateObject$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n  position: absolute;\n\ttop: -32px;\n\tright: 5px;\n\n\t.iconRoot {\n\t\tposition: relative;\n\t\ttop: unset;\n    right: unset;\n\t}\n"])));
var PostAuthContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$4 || (_templateObject2$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tjustify-content: flex-start;\n\tinput.loginCont__input {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tborder-radius: 4px;\n\t\tpadding: 0 20px;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])));
var PostAuthHeader = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$3 || (_templateObject3$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground-color: #e9fcf3;\n\tcolor: #2d67b2;\n\tdisplay: flex;\n  flex-direction: row;\n  gap: 0 10px;\n\tpadding: 12px 16px;\n\tborder-radius: 8px;\n  justify-content: flex-start;\n  align-items: flex-start;\n\tspan {\n\t\tmargin-right: 20px;\n\t}\n\n  .successIcon {\n    transform: scale(0.5);\n    margin: -8px -10px;\n  }\n\n\t.successMsg__title {\n\t\tfont-size: 18px;\n\t\tline-height: 21px;\n\t\tcolor: #18a160;\n    align-self: stretch;\n    font-family: Rubik;\n\t\tfont-weight: 600;\n\t}\n\n\t.successMsg__subTitle {\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\tcolor: #717171;\n    font-family: Rubik;\n    padding-top: 4px;\n\t}\n"])));
var postAuthForms = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$3 || (_templateObject4$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 16px;\n  padding: 16px;\n  border: solid 1px #e4e4e4;\n  border-radius: 8px;\n"])));
var OutlinedInput = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$2 || (_templateObject5$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tpadding-top: 7px;\n\tmargin-bottom: ", ";\n\t\n"])), function (props) {
  return props.applyMargin ? '20px' : '0';
});
var postAuthFormHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject6$1 || (_templateObject6$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n  color: #717171;\n\tmargin-bottom: 12px;\n\tline-height: 14px;\n"])));
var PostAuthSubmitButton = styled_components_browser_esm/* default.button */.ZP.button(growth_gi_dweb_auth_esm_templateObject7 || (growth_gi_dweb_auth_esm_templateObject7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 11px;\n\tmargin-top: 32px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\tfont-size: 18px;\n\tfont-weight: 500;\n  line-height: 21px;\n  font-family: Rubik;\n  text-align: center;\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])));
var SkipUpdate = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject8 || (growth_gi_dweb_auth_esm_templateObject8 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tmargin-top: 30px;\n\n\tbutton {\n\t\tcolor: #008cff !important;\n\t\tcursor: pointer;\n\t\tborder: 0;\n\t\tbackground-color: transparent;\n\t\ttext-decoration: none;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n"])));
var ErrorMsg = styled_components_browser_esm/* default.p */.ZP.p(_templateObject9 || (_templateObject9 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 10px !important;\n\n\tcolor: #e53442;\n"])));
var GenderHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    ", "\n    color: #717171;\n    margin-bottom: 8px;\n    font-family: Rubik;\n    font-size: 12px;\n    line-height: 14px;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var RadioWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    gap: 31px;\n\t\tjustify-content: space-between;\n    label{\n        height: 17px;\n        color: #717171;\n        font-size: 14px;\n        \n    }\n"])));
var RadioInputCont = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12 || (_templateObject12 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    min-width:62px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n"])));
var RadioInput = styled_components_browser_esm/* default.input */.ZP.input(_templateObject13 || (_templateObject13 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 20px;\n    height: 20px;\n    outline: none;\n    border: 2px solid #b0b0b0;\n    -webkit-appearance: none;\n    border-radius: 50%;\n    &:checked {\n        border: 2px solid #2276e3\n\n    ;\n    }\n\n    &:before {\n        content: '';\n        display: block;\n        width: 60%;\n        height: 60%;\n        margin: 20% auto;\n        border-radius: 50%;\n    }\n\n    &:checked:before {\n        background: #2276e3;\n    }\n"])));

var SIGNUP_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'Your account has been created successfully'
};
var LOGIN_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'You have successfully logged in'
};
var DO_IT_LATER = {
  title: 'I’ll do it later'
};
var VALIDATION_MSG = {
  email: {
    invalid: "Enter a valid email"
  },
  name: {
    invalid: "Please enter valid name using only alphabets"
  }
};

var UpdateDetailsForm = function UpdateDetailsForm(_ref) {
  var firstName = _ref.firstName,
    primaryEmailId = _ref.primaryEmailId,
    handleUserUpdate = _ref.handleUserUpdate,
    handleDoItLaterClick = _ref.handleDoItLaterClick,
    apiFailureMsg = _ref.apiFailureMsg,
    isExistingUser = _ref.isExistingUser,
    gender = _ref.gender,
    city = _ref.city;
  var _useState = (0,react.useState)(false),
    isFormValid = _useState[0],
    setIsFormValid = _useState[1];
  var _useState2 = (0,react.useState)(''),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    email = _useState3[0],
    setEmail = _useState3[1];
  var _useState4 = (0,react.useState)(false),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    errorMsg = _useState5[0],
    setErrorMsg = _useState5[1];
  var _useState6 = (0,react.useState)(''),
    selectedGender = _useState6[0],
    setGender = _useState6[1];
  var _useState7 = (0,react.useState)(),
    homeLocationObj = _useState7[0],
    setHomeLocationObj = _useState7[1];
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  (0,react.useEffect)(function () {
    setErrorMsg(apiFailureMsg);
    setIsError(!!apiFailureMsg);
  }, [apiFailureMsg]);
  var handleNameChange = function handleNameChange(e) {
    setName(e.target.value);
  };
  var handleEmailChange = function handleEmailChange(e) {
    setEmail(e.target.value);
  };
  var handleGenderChange = function handleGenderChange(e) {
    setGender(e.target.value);
  };
  var validateProfileUpdate = function validateProfileUpdate(_ref2) {
    var _ref2$fullName = _ref2.fullName,
      fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
      _ref2$inputEmail = _ref2.inputEmail,
      inputEmail = _ref2$inputEmail === void 0 ? '' : _ref2$inputEmail;
    if (fullName && email) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    if (!fullName && inputEmail) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
    }
    if (!inputEmail && fullName) {
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    return {
      isValid: true,
      errorMessage: ''
    };
  };
  var onUserUpdate = function onUserUpdate() {
    var _validateProfileUpdat = validateProfileUpdate({
        fullName: name,
        inputEmail: email
      }),
      isValid = _validateProfileUpdat.isValid,
      errorMessage = _validateProfileUpdat.errorMessage;
    if (isValid) {
      if (handleUserUpdate) handleUserUpdate({
        fullName: name,
        email: email,
        gender: selectedGender,
        homeLocation: homeLocationObj
      });
    } else {
      setErrorMsg(errorMessage);
      setIsError(true);
    }
  };
  var onSkipClick = function onSkipClick() {
    if (handleDoItLaterClick) handleDoItLaterClick();
  };
  (0,react.useEffect)(function () {
    if (name || email || selectedGender || homeLocationObj) {
      setIsFormValid(true);
    } else {
      setIsError(false);
      setErrorMsg('');
    }
  }, [name, email, selectedGender, homeLocationObj]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Profile_Update_Screen_Loaded',
        type: "itemLoaded|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);
  var citySelectHandler = function citySelectHandler(value) {
    var udpatedHomeLocation = {
      cityCode: value == null ? void 0 : value.id,
      cityName: value == null ? void 0 : value.name,
      countryCode: value == null ? void 0 : value.countryCode,
      countryName: value == null ? void 0 : value.countryName
    };
    setHomeLocationObj(udpatedHomeLocation);
  };
  return /*#__PURE__*/react.createElement(postAuthForms, null, /*#__PURE__*/react.createElement(postAuthFormHeading, null, "Just a few more details"), !firstName && /*#__PURE__*/react.createElement(OutlinedInput, {
    applyMargin: true
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    type: "text",
    name: "name",
    label: "Full Name",
    placeholder: "Full Name",
    inputClassName: "loginCont__input",
    inputVal: name,
    onChange: handleNameChange
  })), !primaryEmailId && /*#__PURE__*/react.createElement(OutlinedInput, {
    applyMargin: true
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    type: "email",
    name: "Email",
    label: "Email ID",
    placeholder: "Email ID",
    inputClassName: "loginCont__input",
    inputVal: email,
    onChange: handleEmailChange
  })), !city && /*#__PURE__*/react.createElement(CityDropdown, {
    onCitySelect: citySelectHandler,
    fetchOptions: function fetchOptions(searchText) {
      return (0,growth_api_calls_esm/* fetchCititesList */.HL)({
        q: searchText || ''
      });
    },
    customStyles: {
      listContainer: {
        maxHeight: '200px'
      }
    }
  }), !gender || gender === 'NS' ? /*#__PURE__*/react.createElement("div", {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/react.createElement(GenderHeading, null, "Gender"), /*#__PURE__*/react.createElement(RadioWrapper, null, GENDER_LIST.map(function (item) {
    return /*#__PURE__*/react.createElement(RadioInputCont, {
      key: item.id
    }, /*#__PURE__*/react.createElement(RadioInput, {
      id: item.id,
      type: "radio",
      name: "gender",
      value: item.id,
      defaultChecked: gender === item.id,
      onChange: handleGenderChange
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: item.id
    }, item.label));
  }))) : null, isError && /*#__PURE__*/react.createElement(ErrorMsg, null, errorMsg, " "), /*#__PURE__*/react.createElement(PostAuthSubmitButton, {
    type: "button",
    className: !isFormValid ? 'disabled' : '',
    onClick: onUserUpdate
  }, "Lets Go"), /*#__PURE__*/react.createElement(SkipUpdate, null, /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: onSkipClick || null
  }, DO_IT_LATER.title)));
};

var CloseIcon = function CloseIcon(_ref) {
  var closeAuth = _ref.closeAuth,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/react.createElement(AuthVerificationFlowCloseIcon, {
    className: className,
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icClose",
    onClick: closeAuth,
    role: "presentation"
  }));
};

var UpdateProfile = function UpdateProfile(props) {
  var _userDetails$data, _personalDetails$home;
  var closeAndLogin = props.closeAndLogin,
    onProfileComplete = props.onProfileComplete,
    onLoginComplete = props.onLoginComplete;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(''),
    apiFailureMsg = _useState[0],
    setApiFailureMsg = _useState[1];
  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
      return state.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    countryCode = _useSendOtpStore.countryCode,
    data = _useSendOtpStore.data;
  var _useLoginUserStore = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (s) {
      return {
        userDetails: s.data,
        fetchLoginDetails: s.fetch
      };
    }, shallow/* shallow */.X),
    userDetails = _useLoginUserStore.userDetails,
    fetchLoginDetails = _useLoginUserStore.fetchLoginDetails;
  var _useSignupViaOTPStore = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (s) {
      var _s$data;
      return {
        transactionId: (_s$data = s.data) == null ? void 0 : _s$data.transactionId,
        createNewUser: s.createUser
      };
    }, shallow/* shallow */.X),
    transactionId = _useSignupViaOTPStore.transactionId,
    createNewUser = _useSignupViaOTPStore.createNewUser;
  var updateUserDetails = (0,growth_auth_helpers_esm/* useProfileUpdateStore */.IR)(function (s) {
    return s.fetch;
  });
  var profileDetails = (userDetails == null || (_userDetails$data = userDetails.data) == null || (_userDetails$data = _userDetails$data.profileLoginResponse) == null ? void 0 : _userDetails$data[0]) || {};
  var _ref = profileDetails.userDetails || {},
    _ref$extendedUser = _ref.extendedUser,
    extendedUser = _ref$extendedUser === void 0 ? {} : _ref$extendedUser;
  var _extendedUser$persona = extendedUser.personalDetails,
    personalDetails = _extendedUser$persona === void 0 ? {} : _extendedUser$persona,
    _extendedUser$loginIn = extendedUser.loginInfoList,
    loginInfoList = _extendedUser$loginIn === void 0 ? [] : _extendedUser$loginIn,
    _extendedUser$miscFie = extendedUser.miscFields,
    miscFields = _extendedUser$miscFie === void 0 ? {} : _extendedUser$miscFie;
  var _personalDetails$name = personalDetails.name,
    name = _personalDetails$name === void 0 ? {} : _personalDetails$name,
    gender = personalDetails.gender;
  var cityCode = (_personalDetails$home = personalDetails.homeLocation) == null ? void 0 : _personalDetails$home.cityCode;
  var isExistingUser = (data == null ? void 0 : data.statusCode) === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt;
  var primaryEmailId = '';
  loginInfoList.forEach(function (item) {
    if (item.loginType === 'EMAIL') {
      primaryEmailId = item.loginId;
    }
  });
  if (!primaryEmailId) {
    primaryEmailId = miscFields == null ? void 0 : miscFields.altEmailId;
  }
  var triggerWebEngageEvent = function triggerWebEngageEvent() {
    if (window.webengage) {
      var _userDetails$data2, _userDetailsObj$perso, _userDetailsObj$perso2, _webengage2, _window, _window2;
      var userDetailsObj = (_userDetails$data2 = userDetails.data) == null || (_userDetails$data2 = _userDetails$data2.profileLoginResponse[0]) == null || (_userDetails$data2 = _userDetails$data2.userDetails) == null ? void 0 : _userDetails$data2.extendedUser;
      var firstName = userDetailsObj == null || (_userDetailsObj$perso = userDetailsObj.personalDetails) == null || (_userDetailsObj$perso = _userDetailsObj$perso.name) == null ? void 0 : _userDetailsObj$perso.firstName;
      var lastName = userDetailsObj == null || (_userDetailsObj$perso2 = userDetailsObj.personalDetails) == null || (_userDetailsObj$perso2 = _userDetailsObj$perso2.name) == null ? void 0 : _userDetailsObj$perso2.lastName;
      window.webengage.user.login(userDetailsObj == null ? void 0 : userDetailsObj.uuid);
      if (primaryEmailId) {
        var _webengage;
        (_webengage = window.webengage) == null || (_webengage = _webengage.user) == null || _webengage.setAttribute == null || _webengage.setAttribute('we_email', primaryEmailId);
      }
      (_webengage2 = window.webengage) == null || (_webengage2 = _webengage2.user) == null || _webengage2.setAttribute == null || _webengage2.setAttribute('we_phone', mobileNumber);
      if (firstName) (_window = window) == null || (_window = _window.webengage) == null || (_window = _window.user) == null || _window.setAttribute == null || _window.setAttribute('we_first_name', firstName);
      if (lastName) (_window2 = window) == null || (_window2 = _window2.webengage) == null || (_window2 = _window2.user) == null || _window2.setAttribute == null || _window2.setAttribute('we_last_name', lastName);
      if (!isExistingUser) {
        var _window3;
        (_window3 = window) == null || (_window3 = _window3.webengage) == null || _window3.track == null || _window3.track('Newuser_Signup_event', {
          value: true
        });
      }
    }
  };
  var onLoginSuccess = function onLoginSuccess() {
    // adding timeout as api take some time to remove cache and update user details
    if (onLoginComplete) onLoginComplete(userDetails);
    triggerWebEngageEvent();
  };
  var onLoginError = function onLoginError() {
    setApiFailureMsg('Something went wrong, please try again.');
  };
  var onUserUpdate = function onUserUpdate(_ref2) {
    var fullName = _ref2.fullName,
      email = _ref2.email,
      selectedGender = _ref2.gender,
      homeLocation = _ref2.homeLocation;
    setApiFailureMsg('');
    adobe.track('Profile_Completion');
    if (isExistingUser) {
      var details = {
        mobileNumber: mobileNumber,
        countryCode: "" + countryCode
      };
      if (fullName) details.firstName = fullName;
      if (email) details.email = email;
      if (selectedGender) details.gender = selectedGender;
      if (homeLocation) details.homeLocation = homeLocation;
      updateUserDetails({
        data: details,
        platform: 'dweb',
        onSuccess: onLoginSuccess,
        onError: onLoginError
      });
    } else if (!isExistingUser) {
      createNewUser(growth_gi_dweb_auth_esm_extends({
        platform: 'dweb',
        fullName: fullName,
        email: email,
        mobileNumber: mobileNumber,
        gender: selectedGender,
        countryCode: "" + countryCode,
        transactionId: transactionId
      }, homeLocation && {
        homeLocation: homeLocation
      })).then(function (res) {
        var _res$result;
        if (res != null && (_res$result = res.result) != null && _res$result.success) {
          fetchLoginDetails({
            platform: 'dweb',
            data: {
              mobileNumber: mobileNumber,
              countryCode: "" + countryCode,
              passwordType: 'TRANSITION_ID',
              password: transactionId
            },
            onSuccess: onLoginSuccess,
            onError: onLoginError
          });
        }
      })["catch"](function () {
        return onLoginError();
      });
    }
  };
  var handleDoItLaterClick = function handleDoItLaterClick() {
    adobe.track('ctaClick', {
      cta: {
        name: 'skip-profile-update',
        type: "itemClick|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (isExistingUser) {
      triggerWebEngageEvent();
      if (closeAndLogin) closeAndLogin();
    } else {
      onUserUpdate({
        fullName: '',
        email: '',
        gender: ''
      });
    }
  };
  (0,react.useEffect)(function () {
    if (isExistingUser) {
      if (name.firstName && primaryEmailId && cityCode) {
        onProfileComplete();
        triggerWebEngageEvent();
      }
    }
  }, [isExistingUser, name, primaryEmailId, cityCode]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CloseIconContainer, null, /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: handleDoItLaterClick,
    className: "iconRoot"
  })), /*#__PURE__*/react.createElement(PostAuthContainer, null, /*#__PURE__*/react.createElement(PostAuthHeader, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig successIcon"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, LOGIN_SUCCESS_TOAST.title), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, isExistingUser ? LOGIN_SUCCESS_TOAST.subTitle : SIGNUP_SUCCESS_TOAST.subTitle))), /*#__PURE__*/react.createElement(UpdateDetailsForm, {
    apiFailureMsg: apiFailureMsg,
    firstName: name.firstName,
    gender: gender,
    primaryEmailId: primaryEmailId,
    handleUserUpdate: onUserUpdate,
    handleDoItLaterClick: handleDoItLaterClick,
    isExistingUser: isExistingUser,
    city: cityCode
  })));
};

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1;
var AuthOfferStyle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$5 || (_templateObject$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 343px;\n\theight: 432px;\n\tbackground-color: rgb(255, 255, 255);\n\tborder-radius: 20px 0px 0px 20px;\n\tflex-shrink: 0;\n\toverflow: hidden;\n\tpadding: 22px 20px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t", "\n\tcursor: ", ";\n"])), function (_ref) {
  var bg = _ref.bg;
  return !bg ? "background:linear-gradient(\n\t\t197.24deg,\n\t\trgb(194, 212, 255) 16.45%,\n\t\trgb(251, 241, 255) 39.26%,\n\t\trgb(234, 243, 243) 59.99%\n\t);\n\tbackground-size:0% 0% / cover;" : "background: #fff url(" + bg + ") top left no-repeat;\n\tbackground-size: cover;";
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable ? 'pointer' : 'auto';
});
var offerBannerHeading = styled_components_browser_esm/* default.h3 */.ZP.h3(_templateObject2$3 || (_templateObject2$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n\tcolor: rgb(20, 24, 35);\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var offerBannerSubHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject3$2 || (_templateObject3$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4f525a;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var smooth = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject4$2 || (_templateObject4$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose([" {\n\tfrom {\n\t  opacity: 0;\n\t}\n  \n\tto {\n\t  opacity: 2;\n\t}\n  }"])));
var Smooth = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$1 || (_templateObject5$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tanimation: ", ";\n"])), smooth);

var _templateObject$4, growth_gi_dweb_auth_esm_templateObject2$2, growth_gi_dweb_auth_esm_templateObject3$1, growth_gi_dweb_auth_esm_templateObject4$1, growth_gi_dweb_auth_esm_templateObject5, growth_gi_dweb_auth_esm_templateObject6;
var BenefitsContainer = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject$4 || (_templateObject$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 15px;\n\tmargin-left: -6px;\n"])));
var BenefitsList = styled_components_browser_esm/* default.li */.ZP.li(growth_gi_dweb_auth_esm_templateObject2$2 || (growth_gi_dweb_auth_esm_templateObject2$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t.benefitsList_item_wrapper {\n\t\tflex: 1;\n\t}\n\t.benefitsList_item_IconWrapper {\n\t\twidth: 52px;\n\t\theight: 52px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 20px;\n\t\tmargin-top: -12px;\n\t}\n\n\t.benefitsList_item_IconWrapper.giftIcon {\n\t\tmargin-top: -24px;\n\t}\n\n\t.icGoCash {\n\t\twidth: 73px;\n\t\theight: 44px;\n\t\tbackground: url(https://gos3.ibcdn.com/go-cash-icon-1674207238.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGoTribe {\n\t\twidth: 52px;\n\t\theight: 15px;\n\t\tbackground: url(https://gos3.ibcdn.com/gotribe-logo-1674203779.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGiftBlue {\n\t\twidth: 37px;\n\t\theight: 42px;\n\t\tbackground: url(https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n"])));
var BenifitsImage = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject3$1 || (growth_gi_dweb_auth_esm_templateObject3$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 52px;\n\theight: 52px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tmargin-right: 20px;\n\tbackground: url(", ");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n\tmargin-top: -10px;\n"])), function (props) {
  return props.imgUrl;
});
var BenefitsContainerHeading = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject4$1 || (growth_gi_dweb_auth_esm_templateObject4$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\tmargin-bottom: 6px;\n"])), growth_design_system_esm/* headingSizes.Small */.$G.Small);
var BenefitsContainerSubHeading = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject5 || (growth_gi_dweb_auth_esm_templateObject5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\t&.lastChild {\n\t\tborder-bottom: none;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var BenifitsDivider = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject6 || (growth_gi_dweb_auth_esm_templateObject6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid #cdcdcd;\n\tmargin-top: 20px;\n"])));

var OfferBenefits = function OfferBenefits(props) {
  var _props$benefitsList = props.benefitsList,
    benefitsList = _props$benefitsList === void 0 ? [] : _props$benefitsList;
  return /*#__PURE__*/react.createElement(BenefitsContainer, null, benefitsList.map(function (benefit) {
    return /*#__PURE__*/react.createElement(BenefitsList, {
      key: benefit.id
    }, /*#__PURE__*/react.createElement(BenifitsImage, {
      imgUrl: benefit.imgUrl
    }), /*#__PURE__*/react.createElement("div", {
      className: "benefitsList_item_wrapper"
    }, /*#__PURE__*/react.createElement(BenefitsContainerHeading, null, benefit.heading, " "), /*#__PURE__*/react.createElement(BenefitsContainerSubHeading, null, benefit.subHeading, " "), /*#__PURE__*/react.createElement(BenifitsDivider, null)));
  }));
};

var _templateObject$3, growth_gi_dweb_auth_esm_templateObject2$1, growth_gi_dweb_auth_esm_templateObject3, growth_gi_dweb_auth_esm_templateObject4;
var OfferBanner$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$3 || (_templateObject$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground: rgb(255, 255, 255);\n\tbox-shadow: rgba(0, 0, 0, 0.08) 2px 4px 8px;\n\tborder-radius: 2px;\n\tpadding: 10px 20px;\n\tborder-left: 6px solid rgb(28, 114, 226);\n\twidth: 303px;\n"])));
var OfferBannerHeading = styled_components_browser_esm/* default.p */.ZP.p(growth_gi_dweb_auth_esm_templateObject2$1 || (growth_gi_dweb_auth_esm_templateObject2$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(79, 82, 90);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OfferBannerSubHeading = styled_components_browser_esm/* default.p */.ZP.p(growth_gi_dweb_auth_esm_templateObject3 || (growth_gi_dweb_auth_esm_templateObject3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(101, 102, 104);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var OfferBannerCouponCode = styled_components_browser_esm/* default.p */.ZP.p(growth_gi_dweb_auth_esm_templateObject4 || (growth_gi_dweb_auth_esm_templateObject4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(28, 114, 226);\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);

var OfferBanner = function OfferBanner(props) {
  var heading = props.heading,
    subHeading = props.subHeading,
    couponCode = props.couponCode;
  return /*#__PURE__*/react.createElement(OfferBanner$1, null, /*#__PURE__*/react.createElement(OfferBannerHeading, null, heading), /*#__PURE__*/react.createElement(OfferBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBannerCouponCode, null, couponCode));
};

var growth_gi_dweb_auth_esm_templateObject$2, growth_gi_dweb_auth_esm_templateObject2;
var growth_gi_dweb_auth_esm_Wrap = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject$2 || (growth_gi_dweb_auth_esm_templateObject$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Bg = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject2 || (growth_gi_dweb_auth_esm_templateObject2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 44px;\n\twidth: 44px;\n\tjustify-content: center;\n\talign-items: center;\n\tdisplay: flex;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n\tborder-radius: 50px;\n"])));
var Loader = function Loader() {
  return /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm_Wrap, null, /*#__PURE__*/react.createElement(Bg, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, null)));
};

var DEFAULT_CONFIG = {
  loginPopover: {
    signUp: {
      ctaText: 'Login/Sign Up',
      coupon: 'Use Coupon : WELCOME'
    }
  },
  loginCtaLabels: [{
    text: 'LOGIN / SIGNUP',
    id: 'text_1'
  }, {
    text: 'Exclusive Offers',
    id: 'text_2'
  }, {
    text: 'Earn goCash',
    id: 'text_3'
  }, {
    text: 'Manage Your Trips',
    id: 'text_4'
  }, {
    text: 'LOGIN / SIGNUP',
    id: 'text_5'
  }],
  bookingOffers: {
    growth: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    flights: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    hotels: {
      title: 'FLAT 25% OFF* ',
      subTitle: 'on your first Hotel booking'
    },
    bus: {
      title: 'FLAT 10% OFF*',
      subTitle: 'on your first Bus booking'
    },
    cabs: {
      title: 'Upto 10% OFF*',
      subTitle: 'on your first Cab booking'
    },
    trains: {
      title: 'Zero service fees',
      subTitle: 'on your first Train booking'
    },
    insurance: {
      "title": "FLAT 12% OFF*",
      "subTitle": "on your first Flight booking",
      "coupon": "Use Coupon :  GOIBEBO"
    }
  },
  loginDialog: {
    heading: 'Unlock these benefits',
    subHeading: '',
    salesOffers: {},
    benefits: [{
      id: 1,
      heading: 'Earn goCash',
      subHeading: '100 on Sign Up & Cashback on Bookings',
      imgUrl: 'https://gos3.ibcdn.com/go-cash-icon-1674207238.png'
    }, {
      id: 2,
      heading: 'Loyalty Benefits',
      subHeading: 'Extra Discounts, Free Seat Selection etc.',
      imgUrl: 'https://gos3.ibcdn.com/gotribe-logo-1674203779.png'
    }, {
      id: 3,
      heading: 'Exclusive Offers',
      subHeading: 'Daily Steal Deals & Special Discounts',
      imgUrl: 'https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png'
    }]
  }
};

var AuthOfferBanner = function AuthOfferBanner(props) {
  var _D4, _D5, _D6, _D7;
  var lobName = props.lobName,
    showBanner = props.showBanner;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _ref = useConfigStore(),
    data = _ref.data,
    loading = _ref.loading,
    error = _ref.error,
    loaded = _ref.loaded;
  var configData = function configData() {
    var _data$COMMON;
    var d = data == null || (_data$COMMON = data.COMMON) == null || (_data$COMMON = _data$COMMON[CONFIG_KEY_DWEB_AUTH]) == null ? void 0 : _data$COMMON.data;
    if (loaded && !error && d) {
      return d;
    }
    return DEFAULT_CONFIG;
  };
  var _ref2 = configData(),
    loginDialog = _ref2.loginDialog,
    bookingOffers = _ref2.bookingOffers;
  var _ref3 = loginDialog || {},
    benefits = _ref3.benefits,
    salesOffers = _ref3.salesOffers,
    heading = _ref3.heading,
    subHeading = _ref3.subHeading;
  var D;
  if (showBanner && (salesOffers || bookingOffers)) {
    D = {
      salesOffers: salesOffers == null ? void 0 : salesOffers[lobName],
      bookingOffers: bookingOffers == null ? void 0 : bookingOffers[lobName]
    };
  }
  var hasSalesOffersExpired = function hasSalesOffersExpired() {
    var _D, _D2;
    if ((_D = D) != null && (_D = _D.salesOffers) != null && _D.imgUrl && (_D2 = D) != null && (_D2 = _D2.salesOffers) != null && _D2.expiry) {
      // expire date format: MM/DD/YYYY
      return isDateExpired({
        now: new Date().getTime(),
        expire: new Date(D.salesOffers.expiry).getTime()
      });
    }
    return true;
  };
  var shouldShowSalesImage = !hasSalesOffersExpired();
  var handleSalesImageClick = function handleSalesImageClick() {
    var _D3;
    adobe.track('ctaClick', {
      cta: {
        name: "Sale_Banner_Clicked",
        type: 'itemClick',
        componentName: "GI_USER_ONBOARDING"
      }
    });
    if (shouldShowSalesImage && (_D3 = D) != null && (_D3 = _D3.salesOffers) != null && _D3.ctaUrl) {
      window.open(D.salesOffers.ctaUrl, '_blank');
    }
  };
  (0,react.useEffect)(function () {
    if (loaded) {
      if (shouldShowSalesImage) {
        // send event when sales has to be display
        adobe.track('ctaClick', {
          cta: {
            name: 'Sale_Banner_loaded',
            type: "itemLoaded",
            componentName: "GI_USER_ONBOARDING"
          }
        });
      }
      (0,growth_pdt_push_esm/* pdtPush */.g)("login_leaflet_load", {
        event_detail: {
          event_type: "load_event|onboarding_click",
          event_value: "" + (shouldShowSalesImage ? "sale_flow" : "onboarding_flow")
        }
      });
    }
  }, [loaded, shouldShowSalesImage]);
  if (!showBanner) {
    return null;
  }
  return /*#__PURE__*/react.createElement(AuthOfferStyle, {
    className: "gr-home",
    "data-id": "auth-offer-banner",
    bg: shouldShowSalesImage ? (_D4 = D) == null || (_D4 = _D4.salesOffers) == null ? void 0 : _D4.imgUrl : '',
    onClick: handleSalesImageClick,
    clickable: !!shouldShowSalesImage
  }, loading ? /*#__PURE__*/react.createElement(Loader, null) : /*#__PURE__*/react.createElement(Smooth, null, heading && !shouldShowSalesImage && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(offerBannerHeading, {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/react.createElement(offerBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBenefits, {
    benefitsList: benefits
  })), /*#__PURE__*/react.createElement(OfferBanner, {
    heading: (_D5 = D) == null || (_D5 = _D5.bookingOffers) == null ? void 0 : _D5.title,
    subHeading: (_D6 = D) == null || (_D6 = _D6.bookingOffers) == null ? void 0 : _D6.subTitle,
    couponCode: (_D7 = D) == null || (_D7 = _D7.bookingOffers) == null ? void 0 : _D7.coupon
  }))));
};

var growth_gi_dweb_auth_esm_templateObject$1;
var ToastContainer = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject$1 || (growth_gi_dweb_auth_esm_templateObject$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\ttext-align: left;\n\n\t.icSuccessBig {\n\t\tmargin-right: 40px;\n\t}\n\n\t.successMsg__title {\n\t\t", "\n\t\tcolor: #00962d;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.successMsg__subTitle {\n\t\t", "\n\t\tcolor: #4f525a;\n\t}\n\n\t.closeIcon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t}\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1, growth_design_system_esm/* textSizes.LargeW2 */.iH.LargeW2);

var ProfileCompletedToast = function ProfileCompletedToast(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(growth_toast_esm/* default */.Z, {
    style: {
      'width': '600px',
      'background': '#fff',
      'padding': '30px 40px',
      'alignItems': 'center',
      'borderRadius': '10px',
      'maxHeight': 'unset',
      'zIndex': ' 1025'
    },
    autoHideDuration: 3000,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(ToastContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, "Congratulations"), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, "You have successfully logged in")), /*#__PURE__*/react.createElement("span", {
    role: "presentation",
    onClick: onClose,
    className: " closeIcon logSprite icClose"
  }))));
};

var AuthVerificationFlow = function AuthVerificationFlow(props) {
  var _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    onClose = props.onClose,
    screenName = props.screenName,
    lobName = props.lobName,
    onLoginSuccess = props.onLoginSuccess,
    prefillMobileNumber = props.prefillMobileNumber,
    isMobileNumberDisabled = props.isMobileNumberDisabled,
    skipMobileScreen = props.skipMobileScreen,
    prefillCountryCode = props.prefillCountryCode,
    allowInternationalLogin = props.allowInternationalLogin;
  var _useAuthFlow = useAuthFlow(function (state) {
      return {
        activeAuthFlow: state.activeAuthFlow,
        setActiveAuthFlow: state.setActiveAuthFlow
      };
    }, shallow/* shallow */.X),
    activeAuthFlow = _useAuthFlow.activeAuthFlow,
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
    adobe = _useAnalytics.adobe;
  var _useState = (0,react.useState)(false),
    showSuccessToast = _useState[0],
    setShowSuccessToast = _useState[1];
  (0,react.useEffect)(function () {
    if (screenName) setActiveAuthFlow(screenName);
  }, [screenName, setActiveAuthFlow]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Login_Popup_Load',
        type: "itemLoaded",
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)('login_module_load', {
      event_detail: {
        event_type: 'load_event|onboarding_click',
        event_Value: "onboarding_flow|" + lobName
      }
    });
  }, []);
  var closeAuth = function closeAuth() {
    adobe.track('ctaClick', {
      cta: {
        name: "Close Modal",
        type: "itemClick|flow:" + activeAuthFlow,
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_pdt_push_esm/* pdtPush */.g)('login_module_close', {
      event_detail: {
        event_type: 'click_event',
        event_Value: "onboarding_flow|flow:" + activeAuthFlow
      }
    });
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    if (onClose) onClose();
  };
  var onProfileComplete = function onProfileComplete() {
    setShowSuccessToast(true);
    if (onLoginSuccess) onLoginSuccess();
  };
  var closeAndLogin = function closeAndLogin() {
    var _window$GI;
    /** works on older header, gi-happy-header */
    /** @deprecated */
    if ((_window$GI = window.GI) != null && _window$GI.HeaderEvent) {
      window.GI.HeaderEvent.trigger('LOGIN_SUCCESS');
    }
    growth_dom_event_emitter_esm/* default.emit */.Z.emit(growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP);
    if (onLoginSuccess) onLoginSuccess();
    if (onClose) onClose();
  };
  var onLoginComplete = function onLoginComplete() {
    closeAndLogin();
  };
  if (showSuccessToast) {
    return /*#__PURE__*/react.createElement(ProfileCompletedToast, {
      onClose: onLoginComplete
    });
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(AuthOfferBanner, {
    lobName: lobName,
    showBanner: activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH
  }), /*#__PURE__*/react.createElement(AuthVerificationFlowSection, {
    isPostAuth: activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH,
    "data-id": "auth-flow-section"
  }, showCloseButton && activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH ? /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: closeAuth
  }) : null, activeAuthFlow === AUTH_FLOW_STEPS.STEP_MOBILE && /*#__PURE__*/react.createElement(LoginWithMobile, {
    prefillMobileNumber: prefillMobileNumber,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen,
    prefillCountryCode: prefillCountryCode,
    allowInternationalLogin: allowInternationalLogin
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP && /*#__PURE__*/react.createElement(LoginWithOtp, {
    isMobileNumberDisabled: isMobileNumberDisabled
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH && /*#__PURE__*/react.createElement(UpdateProfile, {
    closeAndLogin: closeAndLogin,
    onProfileComplete: onProfileComplete,
    onLoginComplete: onLoginComplete
  })));
};

var AuthContainer = function AuthContainer(props) {
  var configData = props.configData;

  /** Memorize b/c we don't want to call the setData again if there in no change in configData */
  (0,react.useMemo)(function () {
    if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
  }, [configData]);
  var _useConfigStore = useConfigStore(function (s) {
      return {
        fetchConfigStore: s.fetch
      };
    }, shallow/* shallow */.X),
    fetchConfigStore = _useConfigStore.fetchConfigStore;
  (0,react.useEffect)(function () {
    var _configData$COMMON, _configData$COMMON2;
    var initializeConfigData = configData;
    if (typeof (configData == null || (_configData$COMMON = configData.COMMON) == null ? void 0 : _configData$COMMON[CONFIG_KEY_COUNTRY_LIST]) === "undefined" || typeof (configData == null || (_configData$COMMON2 = configData.COMMON) == null ? void 0 : _configData$COMMON2[CONFIG_KEY_DWEB_AUTH]) === "undefined") {
      initializeConfigData = undefined;
    }
    fetchConfigStore({
      keys: [CONFIG_KEY_DWEB_AUTH, CONFIG_KEY_COUNTRY_LIST],
      lobs: 'COMMON',
      initData: initializeConfigData
    });
  }, []);
  return /*#__PURE__*/react.createElement(AuthContainer$1, {
    "data-id": "auth-container"
  }, /*#__PURE__*/react.createElement(AuthVerificationFlow, props));
};

var growth_gi_dweb_auth_esm_templateObject;
var CommonSpriteStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(growth_gi_dweb_auth_esm_templateObject || (growth_gi_dweb_auth_esm_templateObject = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\n  .logSprite {\n    background: url(https://gos3.ibcdn.com/happy-sprite-1608708553.png) no-repeat;\n    display: inline-block;\n    background-size: 300px 300px;\n    font-size: 0;\n    flex-shrink: 0;\n  }\n\n  .logSprite.icGift {\n    width: 42px;\n    height: 42px;\n    background-position: -10px -9px;\n  }\n\n  .logSprite.icClose {\n    width: 16px;\n    height: 16px;\n    background-position: -180px -8px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSuccessBig {\n    width: 41px;\n    height: 40px;\n    background-position: -60px -11px;\n  }\n\n  .logSprite.icSuccessSmall {\n    width: 19px;\n    height: 18px;\n    background-position: -132px -33px;\n  }\n\n  .logSprite.icShowPassword {\n    width: 17px;\n    height: 15px;\n    background-position: -105px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSms {\n    width: 13px;\n    height: 12px;\n    background-position: -110px -39px;\n  }\n\n  .logSprite.icWhatsapp {\n    width: 13px;\n    height: 12px;\n    background-position: -157px -11px;\n  }\n\n  .logSprite.icInfoPink {\n    width: 18px;\n    height: 19px;\n    background-position: -131px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icEdit {\n    width: 17px;\n    height: 17px;\n    background-position: -157px -34px;\n    cursor: pointer;\n  }\n\n  .logSprite.icOrangeTick {\n    width: 23px;\n    height: 23px;\n    background-position: -179px -29px;\n    cursor: pointer;\n  }\n\n  .ldrShimmer {\n    animation-duration: 1.5s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n    background-size: 800px 104px;\n    position: relative;\n  }\n\n\n\n"])));

var Container = function Container(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    onClose = _ref.onClose,
    lobName = _ref.lobName,
    onLoginSuccess = _ref.onLoginSuccess,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug,
    _ref$isMobileNumberDi = _ref.isMobileNumberDisabled,
    isMobileNumberDisabled = _ref$isMobileNumberDi === void 0 ? false : _ref$isMobileNumberDi,
    _ref$skipMobileScreen = _ref.skipMobileScreen,
    skipMobileScreen = _ref$skipMobileScreen === void 0 ? false : _ref$skipMobileScreen,
    configData = _ref.configData,
    allowInternationalLogin = _ref.allowInternationalLogin;
  var _useState = (0,react.useState)(false),
    isOnClient = _useState[0],
    setIsOnClient = _useState[1];
  (0,react.useEffect)(function () {
    setIsOnClient(true);
  }, []);
  if (isOnClient) {
    var _initAnalytics = initAnalytics({
        lobName: lobName,
        debug: debug
      }),
      adobeInstance = _initAnalytics.adobeInstance;
    return /*#__PURE__*/react.createElement(styled_components_browser_esm/* ThemeProvider */.f6, {
      theme: growth_app_theme_esm/* defaultTheme */.uH
    }, /*#__PURE__*/react.createElement(CommonSpriteStyle, null), /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(AuthContainer, {
      lobName: lobName,
      onLoginSuccess: onLoginSuccess,
      onClose: onClose,
      showCloseButton: showCloseButton,
      prefillMobileNumber: prefillMobileNumber,
      isMobileNumberDisabled: isMobileNumberDisabled,
      skipMobileScreen: skipMobileScreen,
      configData: configData,
      allowInternationalLogin: allowInternationalLogin
    })));
  }
  return null;
};




/***/ }),

/***/ 16963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ fetchRequest)
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function assertPath(path) {
  var type = typeof path;

  if (type !== 'string') {
    throw new TypeError("The path should be a string, instead received a " + type);
  }
}

var parseResponse = function parseResponse(res) {
  // If a body response exists, parse anx extract the possible properties
  var response = res.json();

  try {
    if (res.status >= 200 && res.status < 300) {
      return Promise.resolve(response);
    }

    if (res.status >= 400 && res.status < 599) {
      return response.then(function (data) {
        var errorResponse = {
          response: data,
          status: res.status,
          statusText: res.statusText
        };
        return Promise.reject(errorResponse);
      });
    }
  } catch (_unused) {
    return response.then(function (data) {
      var errorResponse = {
        response: data,
        status: res.status,
        statusText: res.statusText
      };
      return Promise.reject(errorResponse);
    });
  }

  return Promise.resolve(response);
  /* Add any custom logic related to how you want to handle the response
   *
   * In case success is false,
   * trigger a new expection to capture later on request call site
   */
  // throw new Error(JSON.stringify({response,status:res.status,statusText: res.statusText}));
  // Otherwise, simply resolve the received data
};

var fetchRequest = function fetchRequest(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$headers = _options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      _options$query = _options.query,
      query = _options$query === void 0 ? null : _options$query,
      _options$method = _options.method,
      method = _options$method === void 0 ? 'GET' : _options$method,
      _options$timeout = _options.timeout,
      timeout = _options$timeout === void 0 ? null : _options$timeout,
      _options$credentials = _options.credentials,
      credentials = _options$credentials === void 0 ? 'include' : _options$credentials,
      _options$extraOptions = _options.extraOptions,
      extraOptions = _options$extraOptions === void 0 ? {} : _options$extraOptions;
  var _options2 = options,
      body = _options2.body;
  assertPath(path);

  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['content-type'] = 'application/json';
  }

  var genericHeaders = {};

  var reqOptions = _extends({
    method: method,
    headers: _extends({}, genericHeaders, headers),
    credentials: credentials
  }, extraOptions, {
    body: body
  });

  var queryString = '';

  if (query) {
    // Convert to encoded string and prepend with ?
    queryString = new URLSearchParams(query).toString();
    queryString = queryString && "?" + queryString;
  }

  var controller;
  var requestTimeout;

  if (timeout) {
    controller = new AbortController();
    requestTimeout = setTimeout(function () {
      return controller.abort();
    }, timeout);
  }

  function makeFetchRequest(requestMethod) {
    var config = _extends({}, reqOptions, {
      method: requestMethod
    });

    if (timeout && controller) {
      config.signal = controller.signal;
    }

    return fetch("" + path + queryString, config).then(function (res) {
      if (timeout && requestTimeout) {
        clearTimeout(requestTimeout);
      }

      return parseResponse(res);
    });
  }

  return {
    get: function get() {
      return makeFetchRequest('GET');
    },
    post: function post() {
      return makeFetchRequest('POST');
    },
    "delete": function _delete() {
      return makeFetchRequest('DELETE');
    }
  };
};




/***/ })

}]);